import type { AspidaClient, BasicHeaders } from 'aspida';
import { dataToURLString } from 'aspida';
import type { Methods as Methods_gav26b } from './api/temp/abtests/project/e_manuscript_movie/_jobId@string';
import type { Methods as Methods_qjtpnj } from './api/temp/searchcriteria';
import type { Methods as Methods_zjar3e } from './api/v1/abtests/_projectId@string';
import type { Methods as Methods_4k2f96 } from './api/v1/abtests/authenticated/_projectId@string';
import type { Methods as Methods_1dto3en } from './api/v1/abtests/resumeScreeningScoreFiltering';
import type { Methods as Methods_aqdy3t } from './api/v1/applications/scouts/dodaDirect/records';
import type { Methods as Methods_zx81u } from './api/v1/area';
import type { Methods as Methods_tf8qzi } from './api/v1/area/zipCode/suggest';
import type { Methods as Methods_1mbsyq8 } from './api/v1/bookmarks';
import type { Methods as Methods_jpofml } from './api/v1/careerAdvisor/applicableJobs';
import type { Methods as Methods_76f895 } from './api/v1/careerAdvisor/corporateClients/_corporateClientId@string';
import type { Methods as Methods_1bte5gt } from './api/v1/careerAdvisor/corporateClients/_corporateClientId@string/pageLink';
import type { Methods as Methods_cg4zph } from './api/v1/careerAdvisor/corporateClients/pageList';
import type { Methods as Methods_2awc05 } from './api/v1/careerAdvisor/interviews/adjustment/status/count';
import type { Methods as Methods_1a4o39s } from './api/v1/careerAdvisor/jobs';
import type { Methods as Methods_znkox } from './api/v1/careerAdvisor/jobs/_arcsOrderId@number';
import type { Methods as Methods_sxxxfg } from './api/v1/careerAdvisor/jobs/_arcsOrderId@number/generations/_type@string';
import type { Methods as Methods_egpv5z } from './api/v1/careerAdvisor/jobs/_arcsOrderId@number/tags/_textType@string';
import type { Methods as Methods_t0is67 } from './api/v1/careerAdvisor/jobs/application/abandon';
import type { Methods as Methods_1ijkuxd } from './api/v1/careerAdvisor/jobs/bookmark';
import type { Methods as Methods_5cxa8c } from './api/v1/careerAdvisor/jobs/count';
import type { Methods as Methods_1otqdrj } from './api/v1/careerAdvisor/jobs/generations/_type@string/count';
import type { Methods as Methods_1ctwem4 } from './api/v1/careerAdvisor/jobs/markAsRead';
import type { Methods as Methods_vecmdb } from './api/v1/careerAdvisor/jobs/me';
import type { Methods as Methods_lpwzdx } from './api/v1/careerAdvisor/jobs/newArrival/check';
import type { Methods as Methods_1iz1gj3 } from './api/v1/careerAdvisor/jobs/recommendations/count';
import type { Methods as Methods_ou7n4l } from './api/v1/careerAdvisor/jobs/related/otherJobs';
import type { Methods as Methods_1bjjxiq } from './api/v1/careerAdvisor/jobs/score/applicationAndResumeScreening';
import type { Methods as Methods_wqu3f2 } from './api/v1/careerAdvisor/jobs/state';
import type { Methods as Methods_17ftf8m } from './api/v1/careerAdvisor/jobs/visibility/hide';
import type { Methods as Methods_s5tubv } from './api/v1/careerAdvisor/jobs/visibility/show';
import type { Methods as Methods_1htwogb } from './api/v1/careerSkills';
import type { Methods as Methods_11suo5s } from './api/v1/careers/diagnoses';
import type { Methods as Methods_1dgy6qm } from './api/v1/careers/scheduleMaker';
import type { Methods as Methods_v7uizj } from './api/v1/chats/career-counseling/sessions';
import type { Methods as Methods_c5czg7 } from './api/v1/chats/career-counseling/sessions/_sessionId@string';
import type { Methods as Methods_1faw6ue } from './api/v1/chats/career-counseling/sessions/_sessionId@string/results';
import type { Methods as Methods_1vzwoq2 } from './api/v1/companyBlock/companyCount';
import type { Methods as Methods_gi87ab } from './api/v1/companyBlock/companyList';
import type { Methods as Methods_pg4alr } from './api/v1/corporateBookmarks';
import type { Methods as Methods_v7kqnq } from './api/v1/corporateClients/_corporateClientId@number/publicationPhotos';
import type { Methods as Methods_u8ycn4 } from './api/v1/corporateClients/publicationPhotos/arcs/_id@number/manuscript/ca';
import type { Methods as Methods_eop7ob } from './api/v1/corporateClients/publicationPhotos/arcs/_id@number/manuscript/prepareScout';
import type { Methods as Methods_1r1rd4w } from './api/v1/corporateClients/publicationPhotos/job/_jid@number';
import type { Methods as Methods_12orw7k } from './api/v1/counseling/diagnosticquestionnaire/answers/status';
import type { Methods as Methods_1xsbvpp } from './api/v1/desiredConditions';
import type { Methods as Methods_12qz33e } from './api/v1/desiredConditions/incomes';
import type { Methods as Methods_dehlno } from './api/v1/desiredConditions/industries';
import type { Methods as Methods_uoqnuo } from './api/v1/desiredConditions/jobChangePreference';
import type { Methods as Methods_h79eb9 } from './api/v1/desiredConditions/jobChangeReason';
import type { Methods as Methods_11ksnyu } from './api/v1/desiredConditions/jobTypes';
import type { Methods as Methods_18p9zex } from './api/v1/desiredConditions/transferability';
import type { Methods as Methods_ahs46l } from './api/v1/desiredConditions/workLocations';
import type { Methods as Methods_letbhc } from './api/v1/doda/health';
import type { Methods as Methods_1cgypke } from './api/v1/events/_entryId@string';
import type { Methods as Methods_112anur } from './api/v1/fairs/_eventId@string/registrations';
import type { Methods as Methods_xscmms } from './api/v1/fairs/participation';
import type { Methods as Methods_1ar46wa } from './api/v1/featureFlags';
import type { Methods as Methods_13lk0ru } from './api/v1/front/job/search/canonical';
import type { Methods as Methods_8ls0yn } from './api/v1/front/job/search/footerLinkPattern';
import type { Methods as Methods_1nl9x3n } from './api/v1/front/job/search/titlemeta';
import type { Methods as Methods_6lsh3h } from './api/v1/front/jobs/search/label';
import type { Methods as Methods_1iok7j8 } from './api/v1/front/memberRegistration/next';
import type { Methods as Methods_mweons } from './api/v1/image/company';
import type { Methods as Methods_16uy977 } from './api/v1/image/company/_corporateClientId@number/jobOffer/_jobOfferId@number/_photoId@string';
import type { Methods as Methods_ic40xg } from './api/v1/image/job/_id@number';
import type { Methods as Methods_12aks4b } from './api/v1/image/noImage';
import type { Methods as Methods_1yzoaf1 } from './api/v1/image/transparent';
import type { Methods as Methods_h9ruy5 } from './api/v1/industry';
import type { Methods as Methods_1j73hyu } from './api/v1/industry/personal';
import type { Methods as Methods_1if69eo } from './api/v1/job/_jid@string';
import type { Methods as Methods_1cgl7dt } from './api/v1/job/_jid@string/bookmark';
import type { Methods as Methods_tx49zq } from './api/v1/job/_jid@string/clicksCountUp';
import type { Methods as Methods_dxiw0c } from './api/v1/job/_jid@string/markAsRead';
import type { Methods as Methods_1ggb4dr } from './api/v1/job/_jid@string/pvCountUp';
import type { Methods as Methods_1njf7b1 } from './api/v1/job/_jid@string/relationInfoList/_corporateClientId@string';
import type { Methods as Methods_22vnko } from './api/v1/job/_jid@string/tags';
import type { Methods as Methods_1kgnldy } from './api/v1/jobType';
import type { Methods as Methods_1r625qj } from './api/v1/jobType/personal';
import type { Methods as Methods_108luin } from './api/v1/jobs';
import type { Methods as Methods_jk8vjf } from './api/v1/jobs/_jid@string/matchedTags';
import type { Methods as Methods_xmkuy1 } from './api/v1/jobs/applications/_jid@number/count';
import type { Methods as Methods_y0gfj5 } from './api/v1/jobs/applications/_jid@number/similarApplicants/exists';
import type { Methods as Methods_1h3q6m7 } from './api/v1/jobs/corporateJobs';
import type { Methods as Methods_3quz6n } from './api/v1/jobs/count';
import type { Methods as Methods_1hk2ini } from './api/v1/jobs/featured';
import type { Methods as Methods_ipxlww } from './api/v1/jobs/keywords';
import type { Methods as Methods_1nt8tj } from './api/v1/jobs/neararea';
import type { Methods as Methods_1n7iytw } from './api/v1/jobs/ranking/applications';
import type { Methods as Methods_ffa726 } from './api/v1/jobs/recommendations/applicationAndBookmark';
import type { Methods as Methods_jpsqi9 } from './api/v1/jobs/recommendations/applicationAndBookmark/resumeScreeningScoreFiltered';
import type { Methods as Methods_1wdwlro } from './api/v1/jobs/recommendations/favoriteIntentMatch';
import type { Methods as Methods_o81vz4 } from './api/v1/jobs/recommendations/interests';
import type { Methods as Methods_12cxjpx } from './api/v1/jobs/recommendations/plusScout';
import type { Methods as Methods_1n0p2vq } from './api/v1/jobs/recommendations/similarWorkArea';
import type { Methods as Methods_m8ty1i } from './api/v1/jobs/score/compound';
import type { Methods as Methods_16zdarc } from './api/v1/jobs/topics/_id@string';
import type { Methods as Methods_50sevz } from './api/v1/jobs/vector';
import type { Methods as Methods_8ow79u } from './api/v1/jobs/vector/status';
import type { Methods as Methods_13ju89s } from './api/v1/jwttest';
import type { Methods as Methods_1ex2g6 } from './api/v1/mail/unsubscribe';
import type { Methods as Methods_1q66oun } from './api/v1/messages/company/count';
import type { Methods as Methods_led9lj } from './api/v1/postalCodes/_postalCode@string';
import type { Methods as Methods_1aqc38a } from './api/v1/prePublishedScout/jobs/_prePublishedScoutId@number';
import type { Methods as Methods_9h9im2 } from './api/v1/prePublishedScout/jobs/bookmark';
import type { Methods as Methods_c74r9t } from './api/v1/qualifications';
import type { Methods as Methods_1j2bd6z } from './api/v1/questionnaires/externalServiceUsage';
import type { Methods as Methods_zee37p } from './api/v1/railwayCompany';
import type { Methods as Methods_1s2nsd6 } from './api/v1/resume/applications/companies';
import type { Methods as Methods_1vxxs3g } from './api/v1/resume/careers';
import type { Methods as Methods_q9rmt3 } from './api/v1/resume/careers/_itemNo@number';
import type { Methods as Methods_ukmfei } from './api/v1/resume/careers/latest';
import type { Methods as Methods_1aulm0e } from './api/v1/resume/educations';
import type { Methods as Methods_1f4lgnx } from './api/v1/resume/languageSkills';
import type { Methods as Methods_1ck0vqt } from './api/v1/resume/page/desiredConditions';
import type { Methods as Methods_1l1bg7a } from './api/v1/resume/page/languageQualification';
import type { Methods as Methods_45plg3 } from './api/v1/resume/profiles';
import type { Methods as Methods_1up23bt } from './api/v1/resume/residenceStatus';
import type { Methods as Methods_1arbdhu } from './api/v1/savedSearches';
import type { Methods as Methods_itimew } from './api/v1/savedSearches/_no@string';
import type { Methods as Methods_jr3h7h } from './api/v1/scout/job/_jid@string';
import type { Methods as Methods_1rp3slj } from './api/v1/scout/job/_jid@string/markAsRead';
import type { Methods as Methods_1y73qny } from './api/v1/selectJobs/_selectJobCode@string';
import type { Methods as Methods_1en3614 } from './api/v1/selectJobs/_selectJobCode@string/reference';
import type { Methods as Methods_1lob0jk } from './api/v1/selectJobs/jobs';
import type { Methods as Methods_xnzz7g } from './api/v1/selectJobs/jobs/count';
import type { Methods as Methods_c3d0or } from './api/v1/selfPr/samples/_jobTypeMId@string';
import type { Methods as Methods_p1m3fr } from './api/v1/user/dodax/application/identification';
import type { Methods as Methods_z8c2rx } from './api/v1/user/dodax/convert';
import type { Methods as Methods_8s22kz } from './api/v1/user/dodax/convert/agent';
import type { Methods as Methods_kzqanu } from './api/v1/user/service/usageStatus';
import type { Methods as Methods_r5qu0t } from './api/v1/users';
import type { Methods as Methods_s6jemy } from './api/v1/users/account/exists';
import type { Methods as Methods_r6amqk } from './api/v1/users/account/exists/withDodaId';
import type { Methods as Methods_13rc1rs } from './api/v1/users/assessment/annualSalary';
import type { Methods as Methods_1j5k5e5 } from './api/v1/users/careers';
import type { Methods as Methods_wonuzh } from './api/v1/users/careers/jobDescription';
import type { Methods as Methods_1ryk6iy } from './api/v1/users/companyBlock';
import type { Methods as Methods_1fnuzb8 } from './api/v1/users/companyBlock/dataMigration/consent';
import type { Methods as Methods_48lxtp } from './api/v1/users/companyBlock/dataMigration/consent/done';
import type { Methods as Methods_1a0lnsu } from './api/v1/users/dodax/checkRegistration';
import type { Methods as Methods_1w5ssoh } from './api/v1/users/integration/dodax';
import type { Methods as Methods_1ihierz } from './api/v1/users/integration/dodax/agent';
import type { Methods as Methods_hubz5h } from './api/v1/users/overseasPostingCareers';
import type { Methods as Methods_1awuzlh } from './api/v1/users/pino/agreement';
import type { Methods as Methods_1fw831s } from './api/v1/users/qualifications';
import type { Methods as Methods_1kxch4v } from './api/v1/users/registration';
import type { Methods as Methods_maksvn } from './api/v1/users/registration/crypto/encrypt';
import type { Methods as Methods_17pc9a4 } from './api/v1/users/registration/master/days';
import type { Methods as Methods_16wsz1a } from './api/v1/users/registration/master/employmentStatusForPersonal';
import type { Methods as Methods_2yo45e } from './api/v1/users/registration/master/gender';
import type { Methods as Methods_1ey31d1 } from './api/v1/users/registration/master/graduationCalendar';
import type { Methods as Methods_1ddsgg1 } from './api/v1/users/registration/master/graduationStatus';
import type { Methods as Methods_1lbxx2c } from './api/v1/users/registration/master/jobChangeTimes';
import type { Methods as Methods_1kehc1x } from './api/v1/users/registration/master/prefectures';
import type { Methods as Methods_163hsu7 } from './api/v1/users/registration/master/schoolClassification';
import type { Methods as Methods_tf9w78 } from './api/v1/users/registration/master/workingStatus';
import type { Methods as Methods_c95otj } from './api/v1/users/registration/master/years';
import type { Methods as Methods_1y50ktp } from './api/v1/users/selection/documents';
import type { Methods as Methods_glfomf } from './api/v1/users/selection/documents/capturing';
import type { Methods as Methods_qhsoy6 } from './api/v1/users/selection/documents/download';
import type { Methods as Methods_ygkrx2 } from './api/v1/users/selection/documents/histories';
import type { Methods as Methods_wteuny } from './api/v1/users/selection/documents/orderInfo';
import type { Methods as Methods_1l84wo6 } from './api/v1/users/selfPr';
import type { Methods as Methods_fao6xz } from './api/v1/users/service/jobOffer/usageStatus';
import type { Methods as Methods_1mgkiqi } from './api/v1/visaType';
import type { Methods as Methods_w9dtta } from './api/v2/industry';
import type { Methods as Methods_aehoyt } from './api/v2/job/_jid@string';
import type { Methods as Methods_10brc48 } from './api/v2/jobs';
import type { Methods as Methods_wuu0lu } from './api/v2/jobs/neararea';
import type { Methods as Methods_r3ayx4 } from './api/v2/users/registration';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'http://internal-hydrogen-alb-stg-2046329920.ap-northeast-1.elb.amazonaws.com' : baseURL).replace(/\/$/, '');
  const PATH0 = '/api/temp/abtests/project/e_manuscript_movie';
  const PATH1 = '/api/temp/searchcriteria';
  const PATH2 = '/api/v1/abtests';
  const PATH3 = '/api/v1/abtests/authenticated';
  const PATH4 = '/api/v1/abtests/resumeScreeningScoreFiltering';
  const PATH5 = '/api/v1/applications/scouts/dodaDirect/records';
  const PATH6 = '/api/v1/area';
  const PATH7 = '/api/v1/area/zipCode/suggest';
  const PATH8 = '/api/v1/bookmarks';
  const PATH9 = '/api/v1/careerAdvisor/applicableJobs';
  const PATH10 = '/api/v1/careerAdvisor/corporateClients';
  const PATH11 = '/pageLink';
  const PATH12 = '/api/v1/careerAdvisor/corporateClients/pageList';
  const PATH13 = '/api/v1/careerAdvisor/interviews/adjustment/status/count';
  const PATH14 = '/api/v1/careerAdvisor/jobs';
  const PATH15 = '/generations';
  const PATH16 = '/tags';
  const PATH17 = '/api/v1/careerAdvisor/jobs/application/abandon';
  const PATH18 = '/api/v1/careerAdvisor/jobs/bookmark';
  const PATH19 = '/api/v1/careerAdvisor/jobs/count';
  const PATH20 = '/api/v1/careerAdvisor/jobs/generations';
  const PATH21 = '/count';
  const PATH22 = '/api/v1/careerAdvisor/jobs/markAsRead';
  const PATH23 = '/api/v1/careerAdvisor/jobs/me';
  const PATH24 = '/api/v1/careerAdvisor/jobs/newArrival/check';
  const PATH25 = '/api/v1/careerAdvisor/jobs/recommendations/count';
  const PATH26 = '/api/v1/careerAdvisor/jobs/related/otherJobs';
  const PATH27 = '/api/v1/careerAdvisor/jobs/score/applicationAndResumeScreening';
  const PATH28 = '/api/v1/careerAdvisor/jobs/state';
  const PATH29 = '/api/v1/careerAdvisor/jobs/visibility/hide';
  const PATH30 = '/api/v1/careerAdvisor/jobs/visibility/show';
  const PATH31 = '/api/v1/careerSkills';
  const PATH32 = '/api/v1/careers/diagnoses';
  const PATH33 = '/api/v1/careers/scheduleMaker';
  const PATH34 = '/api/v1/chats/career-counseling/sessions';
  const PATH35 = '/results';
  const PATH36 = '/api/v1/companyBlock/companyCount';
  const PATH37 = '/api/v1/companyBlock/companyList';
  const PATH38 = '/api/v1/corporateBookmarks';
  const PATH39 = '/api/v1/corporateClients';
  const PATH40 = '/publicationPhotos';
  const PATH41 = '/api/v1/corporateClients/publicationPhotos/arcs';
  const PATH42 = '/manuscript/ca';
  const PATH43 = '/manuscript/prepareScout';
  const PATH44 = '/api/v1/corporateClients/publicationPhotos/job';
  const PATH45 = '/api/v1/counseling/diagnosticquestionnaire/answers/status';
  const PATH46 = '/api/v1/desiredConditions';
  const PATH47 = '/api/v1/desiredConditions/incomes';
  const PATH48 = '/api/v1/desiredConditions/industries';
  const PATH49 = '/api/v1/desiredConditions/jobChangePreference';
  const PATH50 = '/api/v1/desiredConditions/jobChangeReason';
  const PATH51 = '/api/v1/desiredConditions/jobTypes';
  const PATH52 = '/api/v1/desiredConditions/transferability';
  const PATH53 = '/api/v1/desiredConditions/workLocations';
  const PATH54 = '/api/v1/doda/health';
  const PATH55 = '/api/v1/events';
  const PATH56 = '/api/v1/fairs';
  const PATH57 = '/registrations';
  const PATH58 = '/api/v1/fairs/participation';
  const PATH59 = '/api/v1/featureFlags';
  const PATH60 = '/api/v1/front/job/search/canonical';
  const PATH61 = '/api/v1/front/job/search/footerLinkPattern';
  const PATH62 = '/api/v1/front/job/search/titlemeta';
  const PATH63 = '/api/v1/front/jobs/search/label';
  const PATH64 = '/api/v1/front/memberRegistration/next';
  const PATH65 = '/api/v1/image/company';
  const PATH66 = '/jobOffer';
  const PATH67 = '/api/v1/image/job';
  const PATH68 = '/api/v1/image/noImage';
  const PATH69 = '/api/v1/image/transparent';
  const PATH70 = '/api/v1/industry';
  const PATH71 = '/api/v1/industry/personal';
  const PATH72 = '/api/v1/job';
  const PATH73 = '/bookmark';
  const PATH74 = '/clicksCountUp';
  const PATH75 = '/markAsRead';
  const PATH76 = '/pvCountUp';
  const PATH77 = '/relationInfoList';
  const PATH78 = '/api/v1/jobType';
  const PATH79 = '/api/v1/jobType/personal';
  const PATH80 = '/api/v1/jobs';
  const PATH81 = '/matchedTags';
  const PATH82 = '/api/v1/jobs/applications';
  const PATH83 = '/similarApplicants/exists';
  const PATH84 = '/api/v1/jobs/corporateJobs';
  const PATH85 = '/api/v1/jobs/count';
  const PATH86 = '/api/v1/jobs/featured';
  const PATH87 = '/api/v1/jobs/keywords';
  const PATH88 = '/api/v1/jobs/neararea';
  const PATH89 = '/api/v1/jobs/ranking/applications';
  const PATH90 = '/api/v1/jobs/recommendations/applicationAndBookmark';
  const PATH91 = '/api/v1/jobs/recommendations/applicationAndBookmark/resumeScreeningScoreFiltered';
  const PATH92 = '/api/v1/jobs/recommendations/favoriteIntentMatch';
  const PATH93 = '/api/v1/jobs/recommendations/interests';
  const PATH94 = '/api/v1/jobs/recommendations/plusScout';
  const PATH95 = '/api/v1/jobs/recommendations/similarWorkArea';
  const PATH96 = '/api/v1/jobs/score/compound';
  const PATH97 = '/api/v1/jobs/topics';
  const PATH98 = '/api/v1/jobs/vector';
  const PATH99 = '/api/v1/jobs/vector/status';
  const PATH100 = '/api/v1/jwttest';
  const PATH101 = '/api/v1/mail/unsubscribe';
  const PATH102 = '/api/v1/messages/company/count';
  const PATH103 = '/api/v1/postalCodes';
  const PATH104 = '/api/v1/prePublishedScout/jobs';
  const PATH105 = '/api/v1/prePublishedScout/jobs/bookmark';
  const PATH106 = '/api/v1/qualifications';
  const PATH107 = '/api/v1/questionnaires/externalServiceUsage';
  const PATH108 = '/api/v1/railwayCompany';
  const PATH109 = '/api/v1/resume/applications/companies';
  const PATH110 = '/api/v1/resume/careers';
  const PATH111 = '/api/v1/resume/careers/latest';
  const PATH112 = '/api/v1/resume/educations';
  const PATH113 = '/api/v1/resume/languageSkills';
  const PATH114 = '/api/v1/resume/page/desiredConditions';
  const PATH115 = '/api/v1/resume/page/languageQualification';
  const PATH116 = '/api/v1/resume/profiles';
  const PATH117 = '/api/v1/resume/residenceStatus';
  const PATH118 = '/api/v1/savedSearches';
  const PATH119 = '/api/v1/scout/job';
  const PATH120 = '/api/v1/selectJobs';
  const PATH121 = '/reference';
  const PATH122 = '/api/v1/selectJobs/jobs';
  const PATH123 = '/api/v1/selectJobs/jobs/count';
  const PATH124 = '/api/v1/selfPr/samples';
  const PATH125 = '/api/v1/user/dodax/application/identification';
  const PATH126 = '/api/v1/user/dodax/convert';
  const PATH127 = '/api/v1/user/dodax/convert/agent';
  const PATH128 = '/api/v1/user/service/usageStatus';
  const PATH129 = '/api/v1/users';
  const PATH130 = '/api/v1/users/account/exists';
  const PATH131 = '/api/v1/users/account/exists/withDodaId';
  const PATH132 = '/api/v1/users/assessment/annualSalary';
  const PATH133 = '/api/v1/users/careers';
  const PATH134 = '/api/v1/users/careers/jobDescription';
  const PATH135 = '/api/v1/users/companyBlock';
  const PATH136 = '/api/v1/users/companyBlock/dataMigration/consent';
  const PATH137 = '/api/v1/users/companyBlock/dataMigration/consent/done';
  const PATH138 = '/api/v1/users/dodax/checkRegistration';
  const PATH139 = '/api/v1/users/integration/dodax';
  const PATH140 = '/api/v1/users/integration/dodax/agent';
  const PATH141 = '/api/v1/users/overseasPostingCareers';
  const PATH142 = '/api/v1/users/pino/agreement';
  const PATH143 = '/api/v1/users/qualifications';
  const PATH144 = '/api/v1/users/registration';
  const PATH145 = '/api/v1/users/registration/crypto/encrypt';
  const PATH146 = '/api/v1/users/registration/master/days';
  const PATH147 = '/api/v1/users/registration/master/employmentStatusForPersonal';
  const PATH148 = '/api/v1/users/registration/master/gender';
  const PATH149 = '/api/v1/users/registration/master/graduationCalendar';
  const PATH150 = '/api/v1/users/registration/master/graduationStatus';
  const PATH151 = '/api/v1/users/registration/master/jobChangeTimes';
  const PATH152 = '/api/v1/users/registration/master/prefectures';
  const PATH153 = '/api/v1/users/registration/master/schoolClassification';
  const PATH154 = '/api/v1/users/registration/master/workingStatus';
  const PATH155 = '/api/v1/users/registration/master/years';
  const PATH156 = '/api/v1/users/selection/documents';
  const PATH157 = '/api/v1/users/selection/documents/capturing';
  const PATH158 = '/api/v1/users/selection/documents/download';
  const PATH159 = '/api/v1/users/selection/documents/histories';
  const PATH160 = '/api/v1/users/selection/documents/orderInfo';
  const PATH161 = '/api/v1/users/selfPr';
  const PATH162 = '/api/v1/users/service/jobOffer/usageStatus';
  const PATH163 = '/api/v1/visaType';
  const PATH164 = '/api/v2/industry';
  const PATH165 = '/api/v2/job';
  const PATH166 = '/api/v2/jobs';
  const PATH167 = '/api/v2/jobs/neararea';
  const PATH168 = '/api/v2/users/registration';
  const GET = 'GET';
  const POST = 'POST';
  const PUT = 'PUT';
  const DELETE = 'DELETE';
  const PATCH = 'PATCH';

  return {
    api: {
      temp: {
        abtests: {
          project: {
            e_manuscript_movie: {
              _jobId: (val5: string) => {
                const prefix5 = `${PATH0}/${val5}`;

                return {
                  /**
                   * 現状（Pickupタブあり、動画無し）とテストパターン（Pickupタブなし、動画あり）のABテストを実施する施策
                   * @returns 成功
                   */
                  get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_gav26b['get']['resBody'], BasicHeaders, Methods_gav26b['get']['status']>(prefix, prefix5, GET, option).json(),
                  /**
                   * 現状（Pickupタブあり、動画無し）とテストパターン（Pickupタブなし、動画あり）のABテストを実施する施策
                   * @returns 成功
                   */
                  $get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_gav26b['get']['resBody'], BasicHeaders, Methods_gav26b['get']['status']>(prefix, prefix5, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix5}`,
                };
              },
            },
          },
        },
        searchcriteria: {
          /**
           * 指定した検索条件を保存する
           * @param option.body - 検索条件保存リクエストボディ
           */
          post: (option: { body: Methods_qjtpnj['post']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_qjtpnj['post']['status']>(prefix, PATH1, POST, option).send(),
          /**
           * 指定した検索条件を保存する
           * @param option.body - 検索条件保存リクエストボディ
           */
          $post: (option: { body: Methods_qjtpnj['post']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_qjtpnj['post']['status']>(prefix, PATH1, POST, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH1}`,
        },
      },
      v1: {
        abtests: {
          _projectId: (val3: string) => {
            const prefix3 = `${PATH2}/${val3}`;

            return {
              /**
               * 指定した施策ID、割り当てID（指定なければsidの候補者ID）を用いてABテスト振分け用のグループNoを取得する
               * @returns 成功
               */
              get: (option?: { query?: Methods_zjar3e['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_zjar3e['get']['resBody'], BasicHeaders, Methods_zjar3e['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した施策ID、割り当てID（指定なければsidの候補者ID）を用いてABテスト振分け用のグループNoを取得する
               * @returns 成功
               */
              $get: (option?: { query?: Methods_zjar3e['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_zjar3e['get']['resBody'], BasicHeaders, Methods_zjar3e['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_zjar3e['get']['query'] } | undefined) =>
                `${prefix}${prefix3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            };
          },
          authenticated: {
            _projectId: (val4: string) => {
              const prefix4 = `${PATH3}/${val4}`;

              return {
                /**
                 * 指定した施策ID、割り当てID（認証情報内の候補者ID）を用いてABテスト振分け用のグループNoを取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_4k2f96['get']['resBody'], BasicHeaders, Methods_4k2f96['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定した施策ID、割り当てID（認証情報内の候補者ID）を用いてABテスト振分け用のグループNoを取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_4k2f96['get']['resBody'], BasicHeaders, Methods_4k2f96['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
          },
          resumeScreeningScoreFiltering: {
            /**
             * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント施策のABテスト振分け用のグループNoを取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1dto3en['get']['resBody'], BasicHeaders, Methods_1dto3en['get']['status']>(prefix, PATH4, GET, option).json(),
            /**
             * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント施策のABテスト振分け用のグループNoを取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1dto3en['get']['resBody'], BasicHeaders, Methods_1dto3en['get']['status']>(prefix, PATH4, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH4}`,
          },
        },
        applications: {
          scouts: {
            dodaDirect: {
              records: {
                /**
                 * ダイレクト応募完了後の応募情報を登録する
                 * @param option.body - ダイレクト応募情報登録リクエストボディ
                 */
                post: (option: { body: Methods_aqdy3t['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_aqdy3t['post']['status']>(prefix, PATH5, POST, option).send(),
                /**
                 * ダイレクト応募完了後の応募情報を登録する
                 * @param option.body - ダイレクト応募情報登録リクエストボディ
                 */
                $post: (option: { body: Methods_aqdy3t['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_aqdy3t['post']['status']>(prefix, PATH5, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH5}`,
              },
            },
          },
        },
        area: {
          zipCode: {
            suggest: {
              /**
               * 郵便番号の前方一致で該当する郵便番号・都道府県・市区町村を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_tf8qzi['get']['query'], config?: T | undefined }) =>
                fetch<Methods_tf8qzi['get']['resBody'], BasicHeaders, Methods_tf8qzi['get']['status']>(prefix, PATH7, GET, option).json(),
              /**
               * 郵便番号の前方一致で該当する郵便番号・都道府県・市区町村を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_tf8qzi['get']['query'], config?: T | undefined }) =>
                fetch<Methods_tf8qzi['get']['resBody'], BasicHeaders, Methods_tf8qzi['get']['status']>(prefix, PATH7, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_tf8qzi['get']['query'] } | undefined) =>
                `${prefix}${PATH7}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          /**
           * 地域・都道府県・市区町村・政令指定都市マスタの情報を取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_zx81u['get']['resBody'], BasicHeaders, Methods_zx81u['get']['status']>(prefix, PATH6, GET, option).json(),
          /**
           * 地域・都道府県・市区町村・政令指定都市マスタの情報を取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_zx81u['get']['resBody'], BasicHeaders, Methods_zx81u['get']['status']>(prefix, PATH6, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH6}`,
        },
        bookmarks: {
          /**
           * 気になる求人一覧を取得する。<br />気になる一覧画面での利用は考慮していないため、必要な場合は後方互換性を保ちつつAPIを拡張すること
           * @returns 成功
           */
          get: (option?: { query?: Methods_1mbsyq8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_1mbsyq8['get']['resBody'], BasicHeaders, Methods_1mbsyq8['get']['status']>(prefix, PATH8, GET, option).json(),
          /**
           * 気になる求人一覧を取得する。<br />気になる一覧画面での利用は考慮していないため、必要な場合は後方互換性を保ちつつAPIを拡張すること
           * @returns 成功
           */
          $get: (option?: { query?: Methods_1mbsyq8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_1mbsyq8['get']['resBody'], BasicHeaders, Methods_1mbsyq8['get']['status']>(prefix, PATH8, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1mbsyq8['get']['query'] } | undefined) =>
            `${prefix}${PATH8}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        careerAdvisor: {
          applicableJobs: {
            /**
             * キャリアアドバイザー紹介求人のうち、候補者が応募可能な求人一覧を取得する<br>
             * 応募していない、辞退していない、非表示にしていない、かつ募集期間内の求人をすべて返す<br>
             * 継続的な応募案内やその他の応募可能求人レコメンデーションに利用できる
             * @returns 成功
             */
            get: (option?: { query?: Methods_jpofml['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_jpofml['get']['resBody'], BasicHeaders, Methods_jpofml['get']['status']>(prefix, PATH9, GET, option).json(),
            /**
             * キャリアアドバイザー紹介求人のうち、候補者が応募可能な求人一覧を取得する<br>
             * 応募していない、辞退していない、非表示にしていない、かつ募集期間内の求人をすべて返す<br>
             * 継続的な応募案内やその他の応募可能求人レコメンデーションに利用できる
             * @returns 成功
             */
            $get: (option?: { query?: Methods_jpofml['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_jpofml['get']['resBody'], BasicHeaders, Methods_jpofml['get']['status']>(prefix, PATH9, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_jpofml['get']['query'] } | undefined) =>
              `${prefix}${PATH9}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          corporateClients: {
            _corporateClientId: (val4: string) => {
              const prefix4 = `${PATH10}/${val4}`;

              return {
                pageLink: {
                  /**
                   * 指定された法人顧客IDに該当する、企業ページへの導線情報を取得する
                   * @returns 成功
                   */
                  get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1bte5gt['get']['resBody'], BasicHeaders, Methods_1bte5gt['get']['status']>(prefix, `${prefix4}${PATH11}`, GET, option).json(),
                  /**
                   * 指定された法人顧客IDに該当する、企業ページへの導線情報を取得する
                   * @returns 成功
                   */
                  $get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1bte5gt['get']['resBody'], BasicHeaders, Methods_1bte5gt['get']['status']>(prefix, `${prefix4}${PATH11}`, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix4}${PATH11}`,
                },
                /**
                 * 指定された法人顧客IDに該当する、法人顧客情報を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_76f895['get']['resBody'], BasicHeaders, Methods_76f895['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定された法人顧客IDに該当する、法人顧客情報を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_76f895['get']['resBody'], BasicHeaders, Methods_76f895['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
            pageList: {
              /**
               * 指定された法人顧客ID(複数)に該当する、企業ページ情報を一覧で取得する
               * @returns 成功
               */
              get: (option: { query: Methods_cg4zph['get']['query'], config?: T | undefined }) =>
                fetch<Methods_cg4zph['get']['resBody'], BasicHeaders, Methods_cg4zph['get']['status']>(prefix, PATH12, GET, option).json(),
              /**
               * 指定された法人顧客ID(複数)に該当する、企業ページ情報を一覧で取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_cg4zph['get']['query'], config?: T | undefined }) =>
                fetch<Methods_cg4zph['get']['resBody'], BasicHeaders, Methods_cg4zph['get']['status']>(prefix, PATH12, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_cg4zph['get']['query'] } | undefined) =>
                `${prefix}${PATH12}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          interviews: {
            adjustment: {
              status: {
                count: {
                  /**
                   * 紹介求人の面接調整ステータス毎の件数を取得する
                   * @returns 成功
                   */
                  get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_2awc05['get']['resBody'], BasicHeaders, Methods_2awc05['get']['status']>(prefix, PATH13, GET, option).json(),
                  /**
                   * 紹介求人の面接調整ステータス毎の件数を取得する
                   * @returns 成功
                   */
                  $get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_2awc05['get']['resBody'], BasicHeaders, Methods_2awc05['get']['status']>(prefix, PATH13, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${PATH13}`,
                },
              },
            },
          },
          jobs: {
            _arcsOrderId: (val4: number) => {
              const prefix4 = `${PATH14}/${val4}`;

              return {
                generations: {
                  _type: (val6: string) => {
                    const prefix6 = `${prefix4}${PATH15}/${val6}`;

                    return {
                      /**
                       * キャリアアドバイザー紹介求人の指定された生成タイプのテキストを生成する
                       * @returns 成功
                       */
                      post: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_sxxxfg['post']['resBody'], BasicHeaders, Methods_sxxxfg['post']['status']>(prefix, prefix6, POST, option).json(),
                      /**
                       * キャリアアドバイザー紹介求人の指定された生成タイプのテキストを生成する
                       * @returns 成功
                       */
                      $post: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_sxxxfg['post']['resBody'], BasicHeaders, Methods_sxxxfg['post']['status']>(prefix, prefix6, POST, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix6}`,
                    };
                  },
                },
                tags: {
                  _textType: (val6: string) => {
                    const prefix6 = `${prefix4}${PATH16}/${val6}`;

                    return {
                      /**
                       * キャリアアドバイザー紹介求人のテキストからタグを抽出する
                       * @returns 成功
                       */
                      get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_egpv5z['get']['resBody'], BasicHeaders, Methods_egpv5z['get']['status']>(prefix, prefix6, GET, option).json(),
                      /**
                       * キャリアアドバイザー紹介求人のテキストからタグを抽出する
                       * @returns 成功
                       */
                      $get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_egpv5z['get']['resBody'], BasicHeaders, Methods_egpv5z['get']['status']>(prefix, prefix6, GET, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix6}`,
                    };
                  },
                },
                /**
                 * キャリアアドバイザー紹介求人詳細を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_znkox['get']['resBody'], BasicHeaders, Methods_znkox['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * キャリアアドバイザー紹介求人詳細を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_znkox['get']['resBody'], BasicHeaders, Methods_znkox['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
            application: {
              abandon: {
                /**
                 * キャリアアドバイザー紹介求人の応募離脱情報であるかご落ち情報を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_t0is67['get']['resBody'], BasicHeaders, Methods_t0is67['get']['status']>(prefix, PATH17, GET, option).json(),
                /**
                 * キャリアアドバイザー紹介求人の応募離脱情報であるかご落ち情報を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_t0is67['get']['resBody'], BasicHeaders, Methods_t0is67['get']['status']>(prefix, PATH17, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH17}`,
              },
            },
            bookmark: {
              /**
               * キャリアアドバイザー紹介求人の気になる登録を実施する
               * @param option.body - キャリアアドバイザー紹介求人気になる登録リクエストボディ
               */
              post: (option: { body: Methods_1ijkuxd['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ijkuxd['post']['status']>(prefix, PATH18, POST, option).send(),
              /**
               * キャリアアドバイザー紹介求人の気になる登録を実施する
               * @param option.body - キャリアアドバイザー紹介求人気になる登録リクエストボディ
               */
              $post: (option: { body: Methods_1ijkuxd['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ijkuxd['post']['status']>(prefix, PATH18, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH18}`,
            },
            count: {
              /**
               * キャリアアドバイザー紹介求人の件数を取得する
               * @returns 成功
               */
              get: (option?: { query?: Methods_5cxa8c['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_5cxa8c['get']['resBody'], BasicHeaders, Methods_5cxa8c['get']['status']>(prefix, PATH19, GET, option).json(),
              /**
               * キャリアアドバイザー紹介求人の件数を取得する
               * @returns 成功
               */
              $get: (option?: { query?: Methods_5cxa8c['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_5cxa8c['get']['resBody'], BasicHeaders, Methods_5cxa8c['get']['status']>(prefix, PATH19, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_5cxa8c['get']['query'] } | undefined) =>
                `${prefix}${PATH19}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            generations: {
              _type: (val5: string) => {
                const prefix5 = `${PATH20}/${val5}`;

                return {
                  count: {
                    /**
                     * 当日の指定された生成タイプの生成回数を取得する
                     * @returns 成功
                     */
                    get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_1otqdrj['get']['resBody'], BasicHeaders, Methods_1otqdrj['get']['status']>(prefix, `${prefix5}${PATH21}`, GET, option).json(),
                    /**
                     * 当日の指定された生成タイプの生成回数を取得する
                     * @returns 成功
                     */
                    $get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_1otqdrj['get']['resBody'], BasicHeaders, Methods_1otqdrj['get']['status']>(prefix, `${prefix5}${PATH21}`, GET, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix5}${PATH21}`,
                  },
                };
              },
            },
            markAsRead: {
              /**
               * キャリアアドバイザー紹介求人詳細を閲覧済み登録を行う
               * @param option.body - キャリアアドバイザー紹介求人閲覧済み登録リクエストボディ
               */
              post: (option: { body: Methods_1ctwem4['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ctwem4['post']['status']>(prefix, PATH22, POST, option).send(),
              /**
               * キャリアアドバイザー紹介求人詳細を閲覧済み登録を行う
               * @param option.body - キャリアアドバイザー紹介求人閲覧済み登録リクエストボディ
               */
              $post: (option: { body: Methods_1ctwem4['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ctwem4['post']['status']>(prefix, PATH22, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH22}`,
            },
            me: {
              /**
               * 候補者へ紹介されているキャリアアドバイザー紹介求人の一覧を取得する<br>
               * /careerAdvisor/jobsにも求人一覧を取得するためのエンドポイントがありますが、そちらはリクエストパラメータとしてARCSオーダーIDのリストを指定するインターフェースです<br>
               * 一方、このAPIは「候補者に紹介されている求人一覧」を取得するためのものであり、 絞り込み条件やソート条件などをリクエストで指定できる点で異なります
               * @returns 成功
               */
              get: (option?: { query?: Methods_vecmdb['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_vecmdb['get']['resBody'], BasicHeaders, Methods_vecmdb['get']['status']>(prefix, PATH23, GET, option).json(),
              /**
               * 候補者へ紹介されているキャリアアドバイザー紹介求人の一覧を取得する<br>
               * /careerAdvisor/jobsにも求人一覧を取得するためのエンドポイントがありますが、そちらはリクエストパラメータとしてARCSオーダーIDのリストを指定するインターフェースです<br>
               * 一方、このAPIは「候補者に紹介されている求人一覧」を取得するためのものであり、 絞り込み条件やソート条件などをリクエストで指定できる点で異なります
               * @returns 成功
               */
              $get: (option?: { query?: Methods_vecmdb['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_vecmdb['get']['resBody'], BasicHeaders, Methods_vecmdb['get']['status']>(prefix, PATH23, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_vecmdb['get']['query'] } | undefined) =>
                `${prefix}${PATH23}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            newArrival: {
              check: {
                /**
                 * キャリアアドバイザー紹介求人一覧を新着順で取得した日付を登録する
                 */
                post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_lpwzdx['post']['status']>(prefix, PATH24, POST, option).send(),
                /**
                 * キャリアアドバイザー紹介求人一覧を新着順で取得した日付を登録する
                 */
                $post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_lpwzdx['post']['status']>(prefix, PATH24, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH24}`,
              },
            },
            recommendations: {
              count: {
                /**
                 * AIが推薦したキャリアアドバイザー紹介求人件数を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1iz1gj3['get']['resBody'], BasicHeaders, Methods_1iz1gj3['get']['status']>(prefix, PATH25, GET, option).json(),
                /**
                 * AIが推薦したキャリアアドバイザー紹介求人件数を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1iz1gj3['get']['resBody'], BasicHeaders, Methods_1iz1gj3['get']['status']>(prefix, PATH25, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH25}`,
              },
            },
            related: {
              otherJobs: {
                /**
                 * 法人顧客IDに関連する求人情報(T原稿のみ)を取得する
                 * @returns 成功
                 */
                get: (option: { query: Methods_ou7n4l['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ou7n4l['get']['resBody'], BasicHeaders, Methods_ou7n4l['get']['status']>(prefix, PATH26, GET, option).json(),
                /**
                 * 法人顧客IDに関連する求人情報(T原稿のみ)を取得する
                 * @returns 成功
                 */
                $get: (option: { query: Methods_ou7n4l['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ou7n4l['get']['resBody'], BasicHeaders, Methods_ou7n4l['get']['status']>(prefix, PATH26, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_ou7n4l['get']['query'] } | undefined) =>
                  `${prefix}${PATH26}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            },
            score: {
              applicationAndResumeScreening: {
                /**
                 * キャリアアドバイザー紹介求人のレコメンド合成スコア(応募×書類通過)を取得する
                 * レスポンスはスコアの高い順で安定ソート(stableSort)し返却する
                 * スコアがnullの場合は、末尾にソートされる
                 * @returns 成功
                 */
                get: (option: { query: Methods_1bjjxiq['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1bjjxiq['get']['resBody'], BasicHeaders, Methods_1bjjxiq['get']['status']>(prefix, PATH27, GET, option).json(),
                /**
                 * キャリアアドバイザー紹介求人のレコメンド合成スコア(応募×書類通過)を取得する
                 * レスポンスはスコアの高い順で安定ソート(stableSort)し返却する
                 * スコアがnullの場合は、末尾にソートされる
                 * @returns 成功
                 */
                $get: (option: { query: Methods_1bjjxiq['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1bjjxiq['get']['resBody'], BasicHeaders, Methods_1bjjxiq['get']['status']>(prefix, PATH27, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_1bjjxiq['get']['query'] } | undefined) =>
                  `${prefix}${PATH27}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            },
            state: {
              /**
               * キャリアアドバイザー紹介求人の紹介状況などを取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_wqu3f2['get']['resBody'], BasicHeaders, Methods_wqu3f2['get']['status']>(prefix, PATH28, GET, option).json(),
              /**
               * キャリアアドバイザー紹介求人の紹介状況などを取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_wqu3f2['get']['resBody'], BasicHeaders, Methods_wqu3f2['get']['status']>(prefix, PATH28, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH28}`,
            },
            visibility: {
              hide: {
                /**
                 * 指定された複数の紹介求人を非表示する
                 * @param option.body - キャリアアドバイザー紹介求人非表示登録リクエストボディ
                 */
                post: (option: { body: Methods_17ftf8m['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_17ftf8m['post']['status']>(prefix, PATH29, POST, option).send(),
                /**
                 * 指定された複数の紹介求人を非表示する
                 * @param option.body - キャリアアドバイザー紹介求人非表示登録リクエストボディ
                 */
                $post: (option: { body: Methods_17ftf8m['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_17ftf8m['post']['status']>(prefix, PATH29, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH29}`,
              },
              show: {
                /**
                 * 指定された複数の紹介求人を非表示から表示にする
                 * @param option.body - キャリアアドバイザー紹介求人非表示解除リクエストボディ
                 */
                post: (option: { body: Methods_s5tubv['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_s5tubv['post']['status']>(prefix, PATH30, POST, option).send(),
                /**
                 * 指定された複数の紹介求人を非表示から表示にする
                 * @param option.body - キャリアアドバイザー紹介求人非表示解除リクエストボディ
                 */
                $post: (option: { body: Methods_s5tubv['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_s5tubv['post']['status']>(prefix, PATH30, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH30}`,
              },
            },
            /**
             * キャリアアドバイザー紹介求人一覧を取得する
             * @returns 成功
             */
            get: (option?: { query?: Methods_1a4o39s['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_1a4o39s['get']['resBody'], BasicHeaders, Methods_1a4o39s['get']['status']>(prefix, PATH14, GET, option).json(),
            /**
             * キャリアアドバイザー紹介求人一覧を取得する
             * @returns 成功
             */
            $get: (option?: { query?: Methods_1a4o39s['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_1a4o39s['get']['resBody'], BasicHeaders, Methods_1a4o39s['get']['status']>(prefix, PATH14, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_1a4o39s['get']['query'] } | undefined) =>
              `${prefix}${PATH14}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
        },
        careerSkills: {
          /**
           * 指定された職種小分類IDに対応する経験・スキルのマスタデータを取得します
           * @returns 成功
           */
          get: (option: { query: Methods_1htwogb['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1htwogb['get']['resBody'], BasicHeaders, Methods_1htwogb['get']['status']>(prefix, PATH31, GET, option).json(),
          /**
           * 指定された職種小分類IDに対応する経験・スキルのマスタデータを取得します
           * @returns 成功
           */
          $get: (option: { query: Methods_1htwogb['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1htwogb['get']['resBody'], BasicHeaders, Methods_1htwogb['get']['status']>(prefix, PATH31, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1htwogb['get']['query'] } | undefined) =>
            `${prefix}${PATH31}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        careers: {
          diagnoses: {
            /**
             * 転職スタイル診断の結果を取得する
             * @returns 診断結果の取得に成功しました
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_11suo5s['get']['resBody'], BasicHeaders, Methods_11suo5s['get']['status']>(prefix, PATH32, GET, option).json(),
            /**
             * 転職スタイル診断の結果を取得する
             * @returns 診断結果の取得に成功しました
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_11suo5s['get']['resBody'], BasicHeaders, Methods_11suo5s['get']['status']>(prefix, PATH32, GET, option).json().then(r => r.body),
            /**
             * AIアシスタント向け転職スタイル診断
             * @param option.body - 転職スタイル診断リクエストボディ
             */
            post: (option: { body: Methods_11suo5s['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_11suo5s['post']['status']>(prefix, PATH32, POST, option).send(),
            /**
             * AIアシスタント向け転職スタイル診断
             * @param option.body - 転職スタイル診断リクエストボディ
             */
            $post: (option: { body: Methods_11suo5s['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_11suo5s['post']['status']>(prefix, PATH32, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH32}`,
          },
          scheduleMaker: {
            /**
             * AIエージェント向け転職スケジュール診断結果取得
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1dgy6qm['get']['resBody'], BasicHeaders, Methods_1dgy6qm['get']['status']>(prefix, PATH33, GET, option).json(),
            /**
             * AIエージェント向け転職スケジュール診断結果取得
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1dgy6qm['get']['resBody'], BasicHeaders, Methods_1dgy6qm['get']['status']>(prefix, PATH33, GET, option).json().then(r => r.body),
            /**
             * AIアシスタント向け転職スケジュール生成
             * @param option.body - 転職スケジュールメーカー生成リクエストボディ
             */
            post: (option: { body: Methods_1dgy6qm['post']['reqBody'], headers?: Methods_1dgy6qm['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1dgy6qm['post']['status']>(prefix, PATH33, POST, option).send(),
            /**
             * AIアシスタント向け転職スケジュール生成
             * @param option.body - 転職スケジュールメーカー生成リクエストボディ
             */
            $post: (option: { body: Methods_1dgy6qm['post']['reqBody'], headers?: Methods_1dgy6qm['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1dgy6qm['post']['status']>(prefix, PATH33, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH33}`,
          },
        },
        chats: {
          career_counseling: {
            sessions: {
              _sessionId: (val5: string) => {
                const prefix5 = `${PATH34}/${val5}`;

                return {
                  results: {
                    /**
                     * キャリアカウンセリングの診断結果を取得する
                     * @returns 成功
                     */
                    post: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_1faw6ue['post']['resBody'], BasicHeaders, Methods_1faw6ue['post']['status']>(prefix, `${prefix5}${PATH35}`, POST, option).json(),
                    /**
                     * キャリアカウンセリングの診断結果を取得する
                     * @returns 成功
                     */
                    $post: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_1faw6ue['post']['resBody'], BasicHeaders, Methods_1faw6ue['post']['status']>(prefix, `${prefix5}${PATH35}`, POST, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix5}${PATH35}`,
                  },
                  /**
                   * AIを使ってユーザーと対話し、キャリアを分析する
                   * @returns 成功
                   */
                  post: (option: { body: Methods_c5czg7['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_c5czg7['post']['resBody'], BasicHeaders, Methods_c5czg7['post']['status']>(prefix, prefix5, POST, option).json(),
                  /**
                   * AIを使ってユーザーと対話し、キャリアを分析する
                   * @returns 成功
                   */
                  $post: (option: { body: Methods_c5czg7['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_c5czg7['post']['resBody'], BasicHeaders, Methods_c5czg7['post']['status']>(prefix, prefix5, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix5}`,
                };
              },
              /**
               * キャリアカウンセリングの新規セッションを初期化する
               * @returns 成功
               */
              post: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_v7uizj['post']['resBody'], BasicHeaders, Methods_v7uizj['post']['status']>(prefix, PATH34, POST, option).json(),
              /**
               * キャリアカウンセリングの新規セッションを初期化する
               * @returns 成功
               */
              $post: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_v7uizj['post']['resBody'], BasicHeaders, Methods_v7uizj['post']['status']>(prefix, PATH34, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH34}`,
            },
          },
        },
        companyBlock: {
          companyCount: {
            /**
             * 指定したキーワードを企業名に含む企業のうち、企業名と住所が一意な結果の件数を取得
             * @returns 成功
             */
            get: (option: { query: Methods_1vzwoq2['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1vzwoq2['get']['resBody'], BasicHeaders, Methods_1vzwoq2['get']['status']>(prefix, PATH36, GET, option).json(),
            /**
             * 指定したキーワードを企業名に含む企業のうち、企業名と住所が一意な結果の件数を取得
             * @returns 成功
             */
            $get: (option: { query: Methods_1vzwoq2['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1vzwoq2['get']['resBody'], BasicHeaders, Methods_1vzwoq2['get']['status']>(prefix, PATH36, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_1vzwoq2['get']['query'] } | undefined) =>
              `${prefix}${PATH36}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          companyList: {
            /**
             * 指定したキーワードを企業名に含む企業のうち、企業名と住所が一意な結果の一覧を取得
             * @returns 成功
             */
            get: (option: { query: Methods_gi87ab['get']['query'], config?: T | undefined }) =>
              fetch<Methods_gi87ab['get']['resBody'], BasicHeaders, Methods_gi87ab['get']['status']>(prefix, PATH37, GET, option).json(),
            /**
             * 指定したキーワードを企業名に含む企業のうち、企業名と住所が一意な結果の一覧を取得
             * @returns 成功
             */
            $get: (option: { query: Methods_gi87ab['get']['query'], config?: T | undefined }) =>
              fetch<Methods_gi87ab['get']['resBody'], BasicHeaders, Methods_gi87ab['get']['status']>(prefix, PATH37, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_gi87ab['get']['query'] } | undefined) =>
              `${prefix}${PATH37}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
        },
        corporateBookmarks: {
          /**
           * 対象の個人顧客が持つ企業気になる情報を取得
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_pg4alr['get']['resBody'], BasicHeaders, Methods_pg4alr['get']['status']>(prefix, PATH38, GET, option).json(),
          /**
           * 対象の個人顧客が持つ企業気になる情報を取得
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_pg4alr['get']['resBody'], BasicHeaders, Methods_pg4alr['get']['status']>(prefix, PATH38, GET, option).json().then(r => r.body),
          /**
           * 対象の個人顧客が持つ企業気になる情報を削除
           * @param option.body - 企業気になる情報リクエストボディ
           */
          delete: (option: { body: Methods_pg4alr['delete']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_pg4alr['delete']['status']>(prefix, PATH38, DELETE, option).send(),
          /**
           * 対象の個人顧客が持つ企業気になる情報を削除
           * @param option.body - 企業気になる情報リクエストボディ
           */
          $delete: (option: { body: Methods_pg4alr['delete']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_pg4alr['delete']['status']>(prefix, PATH38, DELETE, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH38}`,
        },
        corporateClients: {
          _corporateClientId: (val3: number) => {
            const prefix3 = `${PATH39}/${val3}`;

            return {
              publicationPhotos: {
                /**
                 * 指定した法人顧客IDから企業の企業公開写真一覧を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_v7kqnq['get']['resBody'], BasicHeaders, Methods_v7kqnq['get']['status']>(prefix, `${prefix3}${PATH40}`, GET, option).json(),
                /**
                 * 指定した法人顧客IDから企業の企業公開写真一覧を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_v7kqnq['get']['resBody'], BasicHeaders, Methods_v7kqnq['get']['status']>(prefix, `${prefix3}${PATH40}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH40}`,
              },
            };
          },
          publicationPhotos: {
            arcs: {
              _id: (val5: number) => {
                const prefix5 = `${PATH41}/${val5}`;

                return {
                  manuscript: {
                    ca: {
                      /**
                       * 指定したARCSオーダーIDからCA求人の企業公開写真一覧を取得する
                       * @returns 成功
                       */
                      get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_u8ycn4['get']['resBody'], BasicHeaders, Methods_u8ycn4['get']['status']>(prefix, `${prefix5}${PATH42}`, GET, option).json(),
                      /**
                       * 指定したARCSオーダーIDからCA求人の企業公開写真一覧を取得する
                       * @returns 成功
                       */
                      $get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_u8ycn4['get']['resBody'], BasicHeaders, Methods_u8ycn4['get']['status']>(prefix, `${prefix5}${PATH42}`, GET, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix5}${PATH42}`,
                    },
                    prepareScout: {
                      /**
                       * 指定したARCSオーダーIDから掲載前スカウトの企業公開写真一覧を取得する
                       * @returns 成功
                       */
                      get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_eop7ob['get']['resBody'], BasicHeaders, Methods_eop7ob['get']['status']>(prefix, `${prefix5}${PATH43}`, GET, option).json(),
                      /**
                       * 指定したARCSオーダーIDから掲載前スカウトの企業公開写真一覧を取得する
                       * @returns 成功
                       */
                      $get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_eop7ob['get']['resBody'], BasicHeaders, Methods_eop7ob['get']['status']>(prefix, `${prefix5}${PATH43}`, GET, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix5}${PATH43}`,
                    },
                  },
                };
              },
            },
            job: {
              _jid: (val5: number) => {
                const prefix5 = `${PATH44}/${val5}`;

                return {
                  /**
                   * 指定した求人IDから企業公開写真一覧を取得する
                   * @returns 成功
                   */
                  get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1r1rd4w['get']['resBody'], BasicHeaders, Methods_1r1rd4w['get']['status']>(prefix, prefix5, GET, option).json(),
                  /**
                   * 指定した求人IDから企業公開写真一覧を取得する
                   * @returns 成功
                   */
                  $get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1r1rd4w['get']['resBody'], BasicHeaders, Methods_1r1rd4w['get']['status']>(prefix, prefix5, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix5}`,
                };
              },
            },
          },
        },
        counseling: {
          diagnosticquestionnaire: {
            answers: {
              status: {
                /**
                 * 診断アンケート(HRAnalyst)回答状況を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_12orw7k['get']['resBody'], BasicHeaders, Methods_12orw7k['get']['status']>(prefix, PATH45, GET, option).json(),
                /**
                 * 診断アンケート(HRAnalyst)回答状況を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_12orw7k['get']['resBody'], BasicHeaders, Methods_12orw7k['get']['status']>(prefix, PATH45, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH45}`,
              },
            },
          },
        },
        desiredConditions: {
          incomes: {
            /**
             * 指定した希望年収を更新する
             * @param option.body - 希望年収更新リクエストボディ
             */
            put: (option: { body: Methods_12qz33e['put']['reqBody'], headers?: Methods_12qz33e['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_12qz33e['put']['status']>(prefix, PATH47, PUT, option).send(),
            /**
             * 指定した希望年収を更新する
             * @param option.body - 希望年収更新リクエストボディ
             */
            $put: (option: { body: Methods_12qz33e['put']['reqBody'], headers?: Methods_12qz33e['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_12qz33e['put']['status']>(prefix, PATH47, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH47}`,
          },
          industries: {
            /**
             * 指定した希望業種を更新する
             * @param option.body - 希望業種更新リクエストボディ
             */
            put: (option: { body: Methods_dehlno['put']['reqBody'], headers?: Methods_dehlno['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_dehlno['put']['status']>(prefix, PATH48, PUT, option).send(),
            /**
             * 指定した希望業種を更新する
             * @param option.body - 希望業種更新リクエストボディ
             */
            $put: (option: { body: Methods_dehlno['put']['reqBody'], headers?: Methods_dehlno['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_dehlno['put']['status']>(prefix, PATH48, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH48}`,
          },
          jobChangePreference: {
            /**
             * 転職活動状況、希望転職時期、転職理由などの転職時の希望情報を取得します
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_uoqnuo['get']['resBody'], BasicHeaders, Methods_uoqnuo['get']['status']>(prefix, PATH49, GET, option).json(),
            /**
             * 転職活動状況、希望転職時期、転職理由などの転職時の希望情報を取得します
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_uoqnuo['get']['resBody'], BasicHeaders, Methods_uoqnuo['get']['status']>(prefix, PATH49, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH49}`,
          },
          jobChangeReason: {
            /**
             * 個人顧客の転職理由を更新する
             * @param option.body - 転職理由更新リクエストボディ
             */
            put: (option: { body: Methods_h79eb9['put']['reqBody'], headers?: Methods_h79eb9['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_h79eb9['put']['status']>(prefix, PATH50, PUT, option).send(),
            /**
             * 個人顧客の転職理由を更新する
             * @param option.body - 転職理由更新リクエストボディ
             */
            $put: (option: { body: Methods_h79eb9['put']['reqBody'], headers?: Methods_h79eb9['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_h79eb9['put']['status']>(prefix, PATH50, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH50}`,
          },
          jobTypes: {
            /**
             * 個人顧客の希望条件職種を更新する
             * @param option.body - 職種のリクエストボディ
             */
            put: (option: { body: Methods_11ksnyu['put']['reqBody'], headers?: Methods_11ksnyu['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_11ksnyu['put']['status']>(prefix, PATH51, PUT, option).send(),
            /**
             * 個人顧客の希望条件職種を更新する
             * @param option.body - 職種のリクエストボディ
             */
            $put: (option: { body: Methods_11ksnyu['put']['reqBody'], headers?: Methods_11ksnyu['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_11ksnyu['put']['status']>(prefix, PATH51, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH51}`,
          },
          transferability: {
            /**
             * 個人顧客希望条件の転居・転勤可否を更新する
             * @param option.body - 転居・転勤可否更新リクエストボディ
             */
            put: (option: { body: Methods_18p9zex['put']['reqBody'], headers?: Methods_18p9zex['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_18p9zex['put']['status']>(prefix, PATH52, PUT, option).send(),
            /**
             * 個人顧客希望条件の転居・転勤可否を更新する
             * @param option.body - 転居・転勤可否更新リクエストボディ
             */
            $put: (option: { body: Methods_18p9zex['put']['reqBody'], headers?: Methods_18p9zex['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_18p9zex['put']['status']>(prefix, PATH52, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH52}`,
          },
          workLocations: {
            /**
             * 個人顧客希望条件勤務地を更新する
             * @param option.body - 希望勤務地更新リクエストボディ
             */
            put: (option: { body: Methods_ahs46l['put']['reqBody'], headers?: Methods_ahs46l['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_ahs46l['put']['status']>(prefix, PATH53, PUT, option).send(),
            /**
             * 個人顧客希望条件勤務地を更新する
             * @param option.body - 希望勤務地更新リクエストボディ
             */
            $put: (option: { body: Methods_ahs46l['put']['reqBody'], headers?: Methods_ahs46l['put']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_ahs46l['put']['status']>(prefix, PATH53, PUT, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH53}`,
          },
          /**
           * ユーザーの希望条件情報を取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1xsbvpp['get']['resBody'], BasicHeaders, Methods_1xsbvpp['get']['status']>(prefix, PATH46, GET, option).json(),
          /**
           * ユーザーの希望条件情報を取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1xsbvpp['get']['resBody'], BasicHeaders, Methods_1xsbvpp['get']['status']>(prefix, PATH46, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH46}`,
        },
        doda: {
          health: {
            /**
             * 「マイページWeb」「ハートコア」に対してヘルスチェックを行い、dodaが利用可能かどうかを返却。
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_letbhc['get']['resBody'], BasicHeaders, Methods_letbhc['get']['status']>(prefix, PATH54, GET, option).json(),
            /**
             * 「マイページWeb」「ハートコア」に対してヘルスチェックを行い、dodaが利用可能かどうかを返却。
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_letbhc['get']['resBody'], BasicHeaders, Methods_letbhc['get']['status']>(prefix, PATH54, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH54}`,
          },
        },
        events: {
          _entryId: (val3: string) => {
            const prefix3 = `${PATH55}/${val3}`;

            return {
              /**
               * 指定した個人顧客エントリーIDからイベント詳細情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1cgypke['get']['resBody'], BasicHeaders, Methods_1cgypke['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した個人顧客エントリーIDからイベント詳細情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1cgypke['get']['resBody'], BasicHeaders, Methods_1cgypke['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
        },
        fairs: {
          _eventId: (val3: string) => {
            const prefix3 = `${PATH56}/${val3}`;

            return {
              registrations: {
                /**
                 * 転職フェアイベントエントリー情報をDBに登録する
                 */
                post: (option: { body: Methods_112anur['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_112anur['post']['status']>(prefix, `${prefix3}${PATH57}`, POST, option).send(),
                /**
                 * 転職フェアイベントエントリー情報をDBに登録する
                 */
                $post: (option: { body: Methods_112anur['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_112anur['post']['status']>(prefix, `${prefix3}${PATH57}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH57}`,
              },
            };
          },
          participation: {
            /**
             * 会員情報を元にEventHubへ参加登録を行う
             * @returns 成功
             */
            post: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_xscmms['post']['resBody'], BasicHeaders, Methods_xscmms['post']['status']>(prefix, PATH58, POST, option).json(),
            /**
             * 会員情報を元にEventHubへ参加登録を行う
             * @returns 成功
             */
            $post: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_xscmms['post']['resBody'], BasicHeaders, Methods_xscmms['post']['status']>(prefix, PATH58, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH58}`,
          },
        },
        featureFlags: {
          /**
           * 指定したパラメータを元にフューチャーフラグを取得する
           * @returns 成功
           */
          get: (option: { query: Methods_1ar46wa['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1ar46wa['get']['resBody'], BasicHeaders, Methods_1ar46wa['get']['status']>(prefix, PATH59, GET, option).json(),
          /**
           * 指定したパラメータを元にフューチャーフラグを取得する
           * @returns 成功
           */
          $get: (option: { query: Methods_1ar46wa['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1ar46wa['get']['resBody'], BasicHeaders, Methods_1ar46wa['get']['status']>(prefix, PATH59, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1ar46wa['get']['query'] } | undefined) =>
            `${prefix}${PATH59}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        front: {
          job: {
            search: {
              canonical: {
                /**
                 * 求人検索画面のcanonicalURLの置換をする
                 * @returns 成功
                 */
                get: (option: { query: Methods_13lk0ru['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_13lk0ru['get']['resBody'], BasicHeaders, Methods_13lk0ru['get']['status']>(prefix, PATH60, GET, option).json(),
                /**
                 * 求人検索画面のcanonicalURLの置換をする
                 * @returns 成功
                 */
                $get: (option: { query: Methods_13lk0ru['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_13lk0ru['get']['resBody'], BasicHeaders, Methods_13lk0ru['get']['status']>(prefix, PATH60, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_13lk0ru['get']['query'] } | undefined) =>
                  `${prefix}${PATH60}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              footerLinkPattern: {
                /**
                 * 下部リンクパターンの取得をする
                 * @returns 成功
                 */
                get: (option: { query: Methods_8ls0yn['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_8ls0yn['get']['resBody'], BasicHeaders, Methods_8ls0yn['get']['status']>(prefix, PATH61, GET, option).json(),
                /**
                 * 下部リンクパターンの取得をする
                 * @returns 成功
                 */
                $get: (option: { query: Methods_8ls0yn['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_8ls0yn['get']['resBody'], BasicHeaders, Methods_8ls0yn['get']['status']>(prefix, PATH61, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_8ls0yn['get']['query'] } | undefined) =>
                  `${prefix}${PATH61}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              titlemeta: {
                /**
                 * SEO関連titleMeta情報の取得をする
                 * @returns 成功
                 */
                get: (option: { query: Methods_1nl9x3n['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1nl9x3n['get']['resBody'], BasicHeaders, Methods_1nl9x3n['get']['status']>(prefix, PATH62, GET, option).json(),
                /**
                 * SEO関連titleMeta情報の取得をする
                 * @returns 成功
                 */
                $get: (option: { query: Methods_1nl9x3n['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1nl9x3n['get']['resBody'], BasicHeaders, Methods_1nl9x3n['get']['status']>(prefix, PATH62, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_1nl9x3n['get']['query'] } | undefined) =>
                  `${prefix}${PATH62}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            },
          },
          jobs: {
            search: {
              label: {
                /**
                 * 指定した検索条件の表示用ラベル文字列を取得する
                 * @returns 成功
                 */
                get: (option?: { query?: Methods_6lsh3h['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_6lsh3h['get']['resBody'], BasicHeaders, Methods_6lsh3h['get']['status']>(prefix, PATH63, GET, option).json(),
                /**
                 * 指定した検索条件の表示用ラベル文字列を取得する
                 * @returns 成功
                 */
                $get: (option?: { query?: Methods_6lsh3h['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_6lsh3h['get']['resBody'], BasicHeaders, Methods_6lsh3h['get']['status']>(prefix, PATH63, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_6lsh3h['get']['query'] } | undefined) =>
                  `${prefix}${PATH63}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            },
          },
          memberRegistration: {
            next: {
              /**
               * 掲載IDに基づく会員登録画面情報を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_1iok7j8['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1iok7j8['get']['resBody'], BasicHeaders, Methods_1iok7j8['get']['status']>(prefix, PATH64, GET, option).json(),
              /**
               * 掲載IDに基づく会員登録画面情報を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_1iok7j8['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1iok7j8['get']['resBody'], BasicHeaders, Methods_1iok7j8['get']['status']>(prefix, PATH64, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1iok7j8['get']['query'] } | undefined) =>
                `${prefix}${PATH64}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
        },
        image: {
          company: {
            _corporateClientId: (val4: number) => {
              const prefix4 = `${PATH65}/${val4}`;

              return {
                jobOffer: {
                  _jobOfferId: (val6: number) => {
                    const prefix6 = `${prefix4}${PATH66}/${val6}`;

                    return {
                      _photoId: (val7: string) => {
                        const prefix7 = `${prefix6}/${val7}`;

                        return {
                          /**
                           * 企業に紐づく求人の制作写真を取得する
                           * @returns 成功
                           */
                          get: (option?: { config?: T | undefined } | undefined) =>
                            fetch<Methods_16uy977['get']['resBody'], BasicHeaders, Methods_16uy977['get']['status']>(prefix, prefix7, GET, option).text(),
                          /**
                           * 企業に紐づく求人の制作写真を取得する
                           * @returns 成功
                           */
                          $get: (option?: { config?: T | undefined } | undefined) =>
                            fetch<Methods_16uy977['get']['resBody'], BasicHeaders, Methods_16uy977['get']['status']>(prefix, prefix7, GET, option).text().then(r => r.body),
                          $path: () => `${prefix}${prefix7}`,
                        };
                      },
                    };
                  },
                },
              };
            },
            /**
             * noImageを取得する
             * @returns 成功
             */
            get: (option?: { query?: Methods_mweons['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_mweons['get']['resBody'], BasicHeaders, Methods_mweons['get']['status']>(prefix, PATH65, GET, option).text(),
            /**
             * noImageを取得する
             * @returns 成功
             */
            $get: (option?: { query?: Methods_mweons['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_mweons['get']['resBody'], BasicHeaders, Methods_mweons['get']['status']>(prefix, PATH65, GET, option).text().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_mweons['get']['query'] } | undefined) =>
              `${prefix}${PATH65}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          job: {
            _id: (val4: number) => {
              const prefix4 = `${PATH67}/${val4}`;

              return {
                /**
                 * 求人詳細画像を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_ic40xg['get']['resBody'], BasicHeaders, Methods_ic40xg['get']['status']>(prefix, prefix4, GET, option).text(),
                /**
                 * 求人詳細画像を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_ic40xg['get']['resBody'], BasicHeaders, Methods_ic40xg['get']['status']>(prefix, prefix4, GET, option).text().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
          },
          noImage: {
            /**
             * NoImage画像を取得する
             * @returns 成功
             */
            get: (option: { query: Methods_12aks4b['get']['query'], config?: T | undefined }) =>
              fetch<Methods_12aks4b['get']['resBody'], BasicHeaders, Methods_12aks4b['get']['status']>(prefix, PATH68, GET, option).text(),
            /**
             * NoImage画像を取得する
             * @returns 成功
             */
            $get: (option: { query: Methods_12aks4b['get']['query'], config?: T | undefined }) =>
              fetch<Methods_12aks4b['get']['resBody'], BasicHeaders, Methods_12aks4b['get']['status']>(prefix, PATH68, GET, option).text().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_12aks4b['get']['query'] } | undefined) =>
              `${prefix}${PATH68}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          transparent: {
            /**
             * Transparent画像を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1yzoaf1['get']['resBody'], BasicHeaders, Methods_1yzoaf1['get']['status']>(prefix, PATH69, GET, option).text(),
            /**
             * Transparent画像を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1yzoaf1['get']['resBody'], BasicHeaders, Methods_1yzoaf1['get']['status']>(prefix, PATH69, GET, option).text().then(r => r.body),
            $path: () => `${prefix}${PATH69}`,
          },
        },
        industry: {
          personal: {
            /**
             * 個人顧客用業種マスタの情報を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j73hyu['get']['resBody'], BasicHeaders, Methods_1j73hyu['get']['status']>(prefix, PATH71, GET, option).json(),
            /**
             * 個人顧客用業種マスタの情報を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j73hyu['get']['resBody'], BasicHeaders, Methods_1j73hyu['get']['status']>(prefix, PATH71, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH71}`,
          },
          /**
           * 検索用業種マスタの情報を取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_h9ruy5['get']['resBody'], BasicHeaders, Methods_h9ruy5['get']['status']>(prefix, PATH70, GET, option).json(),
          /**
           * 検索用業種マスタの情報を取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_h9ruy5['get']['resBody'], BasicHeaders, Methods_h9ruy5['get']['status']>(prefix, PATH70, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH70}`,
        },
        job: {
          _jid: (val3: string) => {
            const prefix3 = `${PATH72}/${val3}`;

            return {
              bookmark: {
                /**
                 * 気になるを登録する
                 * @param option.body - 気になる登録リクエストボディ
                 */
                post: (option: { body: Methods_1cgl7dt['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1cgl7dt['post']['status']>(prefix, `${prefix3}${PATH73}`, POST, option).send(),
                /**
                 * 気になるを登録する
                 * @param option.body - 気になる登録リクエストボディ
                 */
                $post: (option: { body: Methods_1cgl7dt['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1cgl7dt['post']['status']>(prefix, `${prefix3}${PATH73}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH73}`,
              },
              clicksCountUp: {
                /**
                 * 日別クリック数を更新する
                 * @param option.body - 日別クリック更新リクエストボディ
                 */
                post: (option: { body: Methods_tx49zq['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_tx49zq['post']['status']>(prefix, `${prefix3}${PATH74}`, POST, option).send(),
                /**
                 * 日別クリック数を更新する
                 * @param option.body - 日別クリック更新リクエストボディ
                 */
                $post: (option: { body: Methods_tx49zq['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_tx49zq['post']['status']>(prefix, `${prefix3}${PATH74}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH74}`,
              },
              markAsRead: {
                /**
                 * 指定した求人を閲覧済みとする
                 */
                post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_dxiw0c['post']['status']>(prefix, `${prefix3}${PATH75}`, POST, option).send(),
                /**
                 * 指定した求人を閲覧済みとする
                 */
                $post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_dxiw0c['post']['status']>(prefix, `${prefix3}${PATH75}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH75}`,
              },
              pvCountUp: {
                /**
                 * 日別PV数を更新する
                 * @param option.body - 日別PV数更新リクエストボディ
                 */
                post: (option: { body: Methods_1ggb4dr['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1ggb4dr['post']['status']>(prefix, `${prefix3}${PATH76}`, POST, option).send(),
                /**
                 * 日別PV数を更新する
                 * @param option.body - 日別PV数更新リクエストボディ
                 */
                $post: (option: { body: Methods_1ggb4dr['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1ggb4dr['post']['status']>(prefix, `${prefix3}${PATH76}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH76}`,
              },
              relationInfoList: {
                _corporateClientId: (val5: string) => {
                  const prefix5 = `${prefix3}${PATH77}/${val5}`;

                  return {
                    /**
                     * 指定した求人IDと法人顧客IDを基に、企業が募集中のその他求人情報を取得する
                     * @returns 成功
                     */
                    get: (option: { query: Methods_1njf7b1['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_1njf7b1['get']['resBody'], BasicHeaders, Methods_1njf7b1['get']['status']>(prefix, prefix5, GET, option).json(),
                    /**
                     * 指定した求人IDと法人顧客IDを基に、企業が募集中のその他求人情報を取得する
                     * @returns 成功
                     */
                    $get: (option: { query: Methods_1njf7b1['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_1njf7b1['get']['resBody'], BasicHeaders, Methods_1njf7b1['get']['status']>(prefix, prefix5, GET, option).json().then(r => r.body),
                    $path: (option?: { method?: 'get' | undefined; query: Methods_1njf7b1['get']['query'] } | undefined) =>
                      `${prefix}${prefix5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                  };
                },
              },
              tags: {
                /**
                 * 指定した求人IDから、タグのリストを取得する。認証なしで利用可能
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_22vnko['get']['resBody'], BasicHeaders, Methods_22vnko['get']['status']>(prefix, `${prefix3}${PATH16}`, GET, option).json(),
                /**
                 * 指定した求人IDから、タグのリストを取得する。認証なしで利用可能
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_22vnko['get']['resBody'], BasicHeaders, Methods_22vnko['get']['status']>(prefix, `${prefix3}${PATH16}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH16}`,
              },
              /**
               * 指定した求人IDから求人の詳細情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1if69eo['get']['resBody'], BasicHeaders, Methods_1if69eo['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した求人IDから求人の詳細情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1if69eo['get']['resBody'], BasicHeaders, Methods_1if69eo['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
        },
        jobType: {
          personal: {
            /**
             * 個人顧客用職種マスタ取得
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1r625qj['get']['resBody'], BasicHeaders, Methods_1r625qj['get']['status']>(prefix, PATH79, GET, option).json(),
            /**
             * 個人顧客用職種マスタ取得
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1r625qj['get']['resBody'], BasicHeaders, Methods_1r625qj['get']['status']>(prefix, PATH79, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH79}`,
          },
          /**
           * 職種マスタの情報を取得する
           * @returns 成功
           */
          get: (option?: { query?: Methods_1kgnldy['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_1kgnldy['get']['resBody'], BasicHeaders, Methods_1kgnldy['get']['status']>(prefix, PATH78, GET, option).json(),
          /**
           * 職種マスタの情報を取得する
           * @returns 成功
           */
          $get: (option?: { query?: Methods_1kgnldy['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_1kgnldy['get']['resBody'], BasicHeaders, Methods_1kgnldy['get']['status']>(prefix, PATH78, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1kgnldy['get']['query'] } | undefined) =>
            `${prefix}${PATH78}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        jobs: {
          _jid: (val3: string) => {
            const prefix3 = `${PATH80}/${val3}`;

            return {
              matchedTags: {
                /**
                 * 指定された求人IDに対して、ユーザーのスカウトタグと求人をもとに生成したタグの重複を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_jk8vjf['get']['resBody'], BasicHeaders, Methods_jk8vjf['get']['status']>(prefix, `${prefix3}${PATH81}`, GET, option).json(),
                /**
                 * 指定された求人IDに対して、ユーザーのスカウトタグと求人をもとに生成したタグの重複を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_jk8vjf['get']['resBody'], BasicHeaders, Methods_jk8vjf['get']['status']>(prefix, `${prefix3}${PATH81}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH81}`,
              },
            };
          },
          applications: {
            _jid: (val4: number) => {
              const prefix4 = `${PATH82}/${val4}`;

              return {
                count: {
                  /**
                   * 指定した期間の求人応募件数を取得する
                   * @returns 成功
                   */
                  get: (option?: { query?: Methods_xmkuy1['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                    fetch<Methods_xmkuy1['get']['resBody'], BasicHeaders, Methods_xmkuy1['get']['status']>(prefix, `${prefix4}${PATH21}`, GET, option).json(),
                  /**
                   * 指定した期間の求人応募件数を取得する
                   * @returns 成功
                   */
                  $get: (option?: { query?: Methods_xmkuy1['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                    fetch<Methods_xmkuy1['get']['resBody'], BasicHeaders, Methods_xmkuy1['get']['status']>(prefix, `${prefix4}${PATH21}`, GET, option).json().then(r => r.body),
                  $path: (option?: { method?: 'get' | undefined; query: Methods_xmkuy1['get']['query'] } | undefined) =>
                    `${prefix}${prefix4}${PATH21}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
                similarApplicants: {
                  exists: {
                    /**
                     * 指定した求人に、本人が未応募で、かつ類似ユーザーが応募しているかを判定する。
                     * @returns 成功
                     */
                    get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_y0gfj5['get']['resBody'], BasicHeaders, Methods_y0gfj5['get']['status']>(prefix, `${prefix4}${PATH83}`, GET, option).json(),
                    /**
                     * 指定した求人に、本人が未応募で、かつ類似ユーザーが応募しているかを判定する。
                     * @returns 成功
                     */
                    $get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_y0gfj5['get']['resBody'], BasicHeaders, Methods_y0gfj5['get']['status']>(prefix, `${prefix4}${PATH83}`, GET, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix4}${PATH83}`,
                  },
                },
              };
            },
          },
          corporateJobs: {
            /**
             * 指定した法人顧客IDに紐づく求人情報を取得する
             * @returns 成功
             */
            get: (option: { query: Methods_1h3q6m7['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1h3q6m7['get']['resBody'], BasicHeaders, Methods_1h3q6m7['get']['status']>(prefix, PATH84, GET, option).json(),
            /**
             * 指定した法人顧客IDに紐づく求人情報を取得する
             * @returns 成功
             */
            $get: (option: { query: Methods_1h3q6m7['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1h3q6m7['get']['resBody'], BasicHeaders, Methods_1h3q6m7['get']['status']>(prefix, PATH84, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_1h3q6m7['get']['query'] } | undefined) =>
              `${prefix}${PATH84}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          count: {
            /**
             * 非推奨の求人件数取得APIです。jobの GET /api/job/v1/jobs/countを使用してください。
             * @returns 成功
             */
            get: (option?: { query?: Methods_3quz6n['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_3quz6n['get']['resBody'], BasicHeaders, Methods_3quz6n['get']['status']>(prefix, PATH85, GET, option).json(),
            /**
             * 非推奨の求人件数取得APIです。jobの GET /api/job/v1/jobs/countを使用してください。
             * @returns 成功
             */
            $get: (option?: { query?: Methods_3quz6n['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_3quz6n['get']['resBody'], BasicHeaders, Methods_3quz6n['get']['status']>(prefix, PATH85, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_3quz6n['get']['query'] } | undefined) =>
              `${prefix}${PATH85}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          featured: {
            /**
             * 今週の注目求人一覧を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1hk2ini['get']['resBody'], BasicHeaders, Methods_1hk2ini['get']['status']>(prefix, PATH86, GET, option).json(),
            /**
             * 今週の注目求人一覧を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1hk2ini['get']['resBody'], BasicHeaders, Methods_1hk2ini['get']['status']>(prefix, PATH86, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH86}`,
          },
          keywords: {
            /**
             * フリーワード検索時に類似キーワードを取得する
             * @returns 成功
             */
            get: (option: { query: Methods_ipxlww['get']['query'], config?: T | undefined }) =>
              fetch<Methods_ipxlww['get']['resBody'], BasicHeaders, Methods_ipxlww['get']['status']>(prefix, PATH87, GET, option).json(),
            /**
             * フリーワード検索時に類似キーワードを取得する
             * @returns 成功
             */
            $get: (option: { query: Methods_ipxlww['get']['query'], config?: T | undefined }) =>
              fetch<Methods_ipxlww['get']['resBody'], BasicHeaders, Methods_ipxlww['get']['status']>(prefix, PATH87, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_ipxlww['get']['query'] } | undefined) =>
              `${prefix}${PATH87}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          neararea: {
            /**
             * 指定した検索条件から近隣エリアを取得する
             * @returns 成功
             */
            get: (option?: { query?: Methods_1nt8tj['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_1nt8tj['get']['resBody'], BasicHeaders, Methods_1nt8tj['get']['status']>(prefix, PATH88, GET, option).json(),
            /**
             * 指定した検索条件から近隣エリアを取得する
             * @returns 成功
             */
            $get: (option?: { query?: Methods_1nt8tj['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_1nt8tj['get']['resBody'], BasicHeaders, Methods_1nt8tj['get']['status']>(prefix, PATH88, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_1nt8tj['get']['query'] } | undefined) =>
              `${prefix}${PATH88}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          ranking: {
            applications: {
              /**
               * 指定した検索条件から応募数が多い順に求人情報を取得する
               * @returns 成功
               */
              get: (option?: { query?: Methods_1n7iytw['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_1n7iytw['get']['resBody'], BasicHeaders, Methods_1n7iytw['get']['status']>(prefix, PATH89, GET, option).json(),
              /**
               * 指定した検索条件から応募数が多い順に求人情報を取得する
               * @returns 成功
               */
              $get: (option?: { query?: Methods_1n7iytw['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_1n7iytw['get']['resBody'], BasicHeaders, Methods_1n7iytw['get']['status']>(prefix, PATH89, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1n7iytw['get']['query'] } | undefined) =>
                `${prefix}${PATH89}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          recommendations: {
            applicationAndBookmark: {
              resumeScreeningScoreFiltered: {
                /**
                 * 応募・気になる履歴に基づく書類通過しやすいレコメンド求人一覧取得を取得する
                 * @returns 成功
                 */
                get: (option: { query: Methods_jpsqi9['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_jpsqi9['get']['resBody'], BasicHeaders, Methods_jpsqi9['get']['status']>(prefix, PATH91, GET, option).json(),
                /**
                 * 応募・気になる履歴に基づく書類通過しやすいレコメンド求人一覧取得を取得する
                 * @returns 成功
                 */
                $get: (option: { query: Methods_jpsqi9['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_jpsqi9['get']['resBody'], BasicHeaders, Methods_jpsqi9['get']['status']>(prefix, PATH91, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_jpsqi9['get']['query'] } | undefined) =>
                  `${prefix}${PATH91}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              /**
               * 応募・気になる履歴に基づくレコメンド求人一覧を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_ffa726['get']['query'], config?: T | undefined }) =>
                fetch<Methods_ffa726['get']['resBody'], BasicHeaders, Methods_ffa726['get']['status']>(prefix, PATH90, GET, option).json(),
              /**
               * 応募・気になる履歴に基づくレコメンド求人一覧を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_ffa726['get']['query'], config?: T | undefined }) =>
                fetch<Methods_ffa726['get']['resBody'], BasicHeaders, Methods_ffa726['get']['status']>(prefix, PATH90, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_ffa726['get']['query'] } | undefined) =>
                `${prefix}${PATH90}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            favoriteIntentMatch: {
              /**
               * ユーザーの求人アクション履歴（応募・気になる・閲覧）に基づいてレコメンデーションされた求人一覧を取得する
               * @returns 成功
               */
              get: (option?: { query?: Methods_1wdwlro['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_1wdwlro['get']['resBody'], BasicHeaders, Methods_1wdwlro['get']['status']>(prefix, PATH92, GET, option).json(),
              /**
               * ユーザーの求人アクション履歴（応募・気になる・閲覧）に基づいてレコメンデーションされた求人一覧を取得する
               * @returns 成功
               */
              $get: (option?: { query?: Methods_1wdwlro['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                fetch<Methods_1wdwlro['get']['resBody'], BasicHeaders, Methods_1wdwlro['get']['status']>(prefix, PATH92, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1wdwlro['get']['query'] } | undefined) =>
                `${prefix}${PATH92}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            interests: {
              /**
               * ユーザー情報からユーザーの興味に近い求人一覧を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_o81vz4['get']['resBody'], BasicHeaders, Methods_o81vz4['get']['status']>(prefix, PATH93, GET, option).json(),
              /**
               * ユーザー情報からユーザーの興味に近い求人一覧を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_o81vz4['get']['resBody'], BasicHeaders, Methods_o81vz4['get']['status']>(prefix, PATH93, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH93}`,
            },
            plusScout: {
              /**
               * 指定した条件からプラススカウト求人のレコメンド一覧を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_12cxjpx['get']['query'], config?: T | undefined }) =>
                fetch<Methods_12cxjpx['get']['resBody'], BasicHeaders, Methods_12cxjpx['get']['status']>(prefix, PATH94, GET, option).json(),
              /**
               * 指定した条件からプラススカウト求人のレコメンド一覧を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_12cxjpx['get']['query'], config?: T | undefined }) =>
                fetch<Methods_12cxjpx['get']['resBody'], BasicHeaders, Methods_12cxjpx['get']['status']>(prefix, PATH94, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_12cxjpx['get']['query'] } | undefined) =>
                `${prefix}${PATH94}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
            similarWorkArea: {
              /**
               * 求人の勤務地域に基づく類似レコメンド求人一覧を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_1n0p2vq['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1n0p2vq['get']['resBody'], BasicHeaders, Methods_1n0p2vq['get']['status']>(prefix, PATH95, GET, option).json(),
              /**
               * 求人の勤務地域に基づく類似レコメンド求人一覧を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_1n0p2vq['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1n0p2vq['get']['resBody'], BasicHeaders, Methods_1n0p2vq['get']['status']>(prefix, PATH95, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1n0p2vq['get']['query'] } | undefined) =>
                `${prefix}${PATH95}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          score: {
            compound: {
              /**
               * Scikick APIを使用して、指定された求人一覧の領域横断合成スコアを取得し、
               * スコアの降順でソートして返します。
               *
               * 各求人項目には以下を含めることができます:
               * - arcsOrderIdのみ（重複可）
               * - jobIdのみ（重複可）
               * - arcsOrderIdとjobIdの両方
               *
               * スコアリングには、applicationWeight（応募ウェイト）とplusWeight（プラスウェイト）パラメータを使用して計算します。
               * クライアントサービスは必要に応じて返された結果をフィルタリングまたはページネーションできます。
               * @returns 成功
               */
              post: (option: { body: Methods_m8ty1i['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_m8ty1i['post']['resBody'], BasicHeaders, Methods_m8ty1i['post']['status']>(prefix, PATH96, POST, option).json(),
              /**
               * Scikick APIを使用して、指定された求人一覧の領域横断合成スコアを取得し、
               * スコアの降順でソートして返します。
               *
               * 各求人項目には以下を含めることができます:
               * - arcsOrderIdのみ（重複可）
               * - jobIdのみ（重複可）
               * - arcsOrderIdとjobIdの両方
               *
               * スコアリングには、applicationWeight（応募ウェイト）とplusWeight（プラスウェイト）パラメータを使用して計算します。
               * クライアントサービスは必要に応じて返された結果をフィルタリングまたはページネーションできます。
               * @returns 成功
               */
              $post: (option: { body: Methods_m8ty1i['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_m8ty1i['post']['resBody'], BasicHeaders, Methods_m8ty1i['post']['status']>(prefix, PATH96, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH96}`,
            },
          },
          topics: {
            _id: (val4: string) => {
              const prefix4 = `${PATH97}/${val4}`;

              return {
                /**
                 * 指定した特集枠IDを基に特集枠情報および求人検索条件を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_16zdarc['get']['resBody'], BasicHeaders, Methods_16zdarc['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定した特集枠IDを基に特集枠情報および求人検索条件を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_16zdarc['get']['resBody'], BasicHeaders, Methods_16zdarc['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
          },
          vector: {
            status: {
              /**
               * ベクトル求人検索が有効か確認する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_8ow79u['get']['resBody'], BasicHeaders, Methods_8ow79u['get']['status']>(prefix, PATH99, GET, option).json(),
              /**
               * ベクトル求人検索が有効か確認する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_8ow79u['get']['resBody'], BasicHeaders, Methods_8ow79u['get']['status']>(prefix, PATH99, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH99}`,
            },
            /**
             * 指定した検索条件からベクトル求人一覧を取得する
             * @returns 成功
             */
            get: (option?: { query?: Methods_50sevz['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_50sevz['get']['resBody'], BasicHeaders, Methods_50sevz['get']['status']>(prefix, PATH98, GET, option).json(),
            /**
             * 指定した検索条件からベクトル求人一覧を取得する
             * @returns 成功
             */
            $get: (option?: { query?: Methods_50sevz['get']['query'] | undefined, config?: T | undefined } | undefined) =>
              fetch<Methods_50sevz['get']['resBody'], BasicHeaders, Methods_50sevz['get']['status']>(prefix, PATH98, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_50sevz['get']['query'] } | undefined) =>
              `${prefix}${PATH98}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          /**
           * 指定した検索条件から求人一覧を取得する
           * @returns 成功
           */
          get: (option?: { query?: Methods_108luin['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_108luin['get']['resBody'], BasicHeaders, Methods_108luin['get']['status']>(prefix, PATH80, GET, option).json(),
          /**
           * 指定した検索条件から求人一覧を取得する
           * @returns 成功
           */
          $get: (option?: { query?: Methods_108luin['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_108luin['get']['resBody'], BasicHeaders, Methods_108luin['get']['status']>(prefix, PATH80, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_108luin['get']['query'] } | undefined) =>
            `${prefix}${PATH80}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        jwttest: {
          /**
           * テスト
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_13ju89s['get']['resBody'], BasicHeaders, Methods_13ju89s['get']['status']>(prefix, PATH100, GET, option).text(),
          /**
           * テスト
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_13ju89s['get']['resBody'], BasicHeaders, Methods_13ju89s['get']['status']>(prefix, PATH100, GET, option).text().then(r => r.body),
          $path: () => `${prefix}${PATH100}`,
        },
        mail: {
          unsubscribe: {
            /**
             * メール購読解除の登録をする
             */
            post: (option: { query: Methods_1ex2g6['post']['query'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ex2g6['post']['status']>(prefix, PATH101, POST, option).send(),
            /**
             * メール購読解除の登録をする
             */
            $post: (option: { query: Methods_1ex2g6['post']['query'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ex2g6['post']['status']>(prefix, PATH101, POST, option).send().then(r => r.body),
            $path: (option?: { method: 'post'; query: Methods_1ex2g6['post']['query'] } | undefined) =>
              `${prefix}${PATH101}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
        },
        messages: {
          company: {
            count: {
              /**
               * 企業からのメッセージ件数情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1q66oun['get']['resBody'], BasicHeaders, Methods_1q66oun['get']['status']>(prefix, PATH102, GET, option).json(),
              /**
               * 企業からのメッセージ件数情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1q66oun['get']['resBody'], BasicHeaders, Methods_1q66oun['get']['status']>(prefix, PATH102, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH102}`,
            },
          },
        },
        postalCodes: {
          _postalCode: (val3: string) => {
            const prefix3 = `${PATH103}/${val3}`;

            return {
              /**
               * 郵便番号から住所を取得する。
               * 郵便番号に複数の住所情報が存在するケースがあるが、取得された先頭の1件を返却している。
               * 本来リストで返却するべきのため、新規での利用は非推奨とする。
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_led9lj['get']['resBody'], BasicHeaders, Methods_led9lj['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 郵便番号から住所を取得する。
               * 郵便番号に複数の住所情報が存在するケースがあるが、取得された先頭の1件を返却している。
               * 本来リストで返却するべきのため、新規での利用は非推奨とする。
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_led9lj['get']['resBody'], BasicHeaders, Methods_led9lj['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
        },
        prePublishedScout: {
          jobs: {
            _prePublishedScoutId: (val4: number) => {
              const prefix4 = `${PATH104}/${val4}`;

              return {
                /**
                 * 掲載前スカウトに紐づく求人詳細を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1aqc38a['get']['resBody'], BasicHeaders, Methods_1aqc38a['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 掲載前スカウトに紐づく求人詳細を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1aqc38a['get']['resBody'], BasicHeaders, Methods_1aqc38a['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
            bookmark: {
              /**
               * 掲載前スカウト求人を気になる登録する
               * @param option.body - 掲載前スカウト求人気になる登録リクエストボディ
               */
              post: (option: { body: Methods_9h9im2['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_9h9im2['post']['status']>(prefix, PATH105, POST, option).send(),
              /**
               * 掲載前スカウト求人を気になる登録する
               * @param option.body - 掲載前スカウト求人気になる登録リクエストボディ
               */
              $post: (option: { body: Methods_9h9im2['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_9h9im2['post']['status']>(prefix, PATH105, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH105}`,
            },
          },
        },
        qualifications: {
          /**
           * 資格一覧情報を取得する
           * @returns 成功
           */
          get: (option?: { query?: Methods_c74r9t['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_c74r9t['get']['resBody'], BasicHeaders, Methods_c74r9t['get']['status']>(prefix, PATH106, GET, option).json(),
          /**
           * 資格一覧情報を取得する
           * @returns 成功
           */
          $get: (option?: { query?: Methods_c74r9t['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_c74r9t['get']['resBody'], BasicHeaders, Methods_c74r9t['get']['status']>(prefix, PATH106, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_c74r9t['get']['query'] } | undefined) =>
            `${prefix}${PATH106}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        questionnaires: {
          externalServiceUsage: {
            /**
             * ユーザーが希望条件登録画面で登録した、他社人材紹介会社利用状況のアンケート結果を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j2bd6z['get']['resBody'], BasicHeaders, Methods_1j2bd6z['get']['status']>(prefix, PATH107, GET, option).json(),
            /**
             * ユーザーが希望条件登録画面で登録した、他社人材紹介会社利用状況のアンケート結果を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j2bd6z['get']['resBody'], BasicHeaders, Methods_1j2bd6z['get']['status']>(prefix, PATH107, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH107}`,
          },
        },
        railwayCompany: {
          /**
           * 鉄道マスタの情報を取得する
           * @returns 成功
           */
          get: (option?: { query?: Methods_zee37p['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_zee37p['get']['resBody'], BasicHeaders, Methods_zee37p['get']['status']>(prefix, PATH108, GET, option).json(),
          /**
           * 鉄道マスタの情報を取得する
           * @returns 成功
           */
          $get: (option?: { query?: Methods_zee37p['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_zee37p['get']['resBody'], BasicHeaders, Methods_zee37p['get']['status']>(prefix, PATH108, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_zee37p['get']['query'] } | undefined) =>
            `${prefix}${PATH108}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        resume: {
          applications: {
            companies: {
              /**
               * 希望条件画面にてユーザーが登録した応募企業（状況・結果）の情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1s2nsd6['get']['resBody'], BasicHeaders, Methods_1s2nsd6['get']['status']>(prefix, PATH109, GET, option).json(),
              /**
               * 希望条件画面にてユーザーが登録した応募企業（状況・結果）の情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1s2nsd6['get']['resBody'], BasicHeaders, Methods_1s2nsd6['get']['status']>(prefix, PATH109, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH109}`,
            },
          },
          careers: {
            _itemNo: (val4: number) => {
              const prefix4 = `${PATH110}/${val4}`;

              return {
                /**
                 * 指定された明細NOに紐づく直近勤務先の職務内容を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_q9rmt3['get']['resBody'], BasicHeaders, Methods_q9rmt3['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定された明細NOに紐づく直近勤務先の職務内容を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_q9rmt3['get']['resBody'], BasicHeaders, Methods_q9rmt3['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
            latest: {
              /**
               * 職歴が２件以下の場合に、新規で一件追加するようにする。<br>
               * 既存でほかの職歴がある場合はそれを繰り下げる
               * @param option.body - 最新職務経歴更新リクエストボディ
               */
              post: (option: { body: Methods_ukmfei['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_ukmfei['post']['status']>(prefix, PATH111, POST, option).send(),
              /**
               * 職歴が２件以下の場合に、新規で一件追加するようにする。<br>
               * 既存でほかの職歴がある場合はそれを繰り下げる
               * @param option.body - 最新職務経歴更新リクエストボディ
               */
              $post: (option: { body: Methods_ukmfei['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_ukmfei['post']['status']>(prefix, PATH111, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH111}`,
            },
            /**
             * 個人顧客向けに自分の職歴を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1vxxs3g['get']['resBody'], BasicHeaders, Methods_1vxxs3g['get']['status']>(prefix, PATH110, GET, option).json(),
            /**
             * 個人顧客向けに自分の職歴を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1vxxs3g['get']['resBody'], BasicHeaders, Methods_1vxxs3g['get']['status']>(prefix, PATH110, GET, option).json().then(r => r.body),
            /**
             * 職務経歴登録画面用の登録API。<br>
             * 汎用的に作るべきところを職務経歴登録画面のトランザクション管理のため、専用のAPIとして定義している。<br>
             * そのため、他画面での使用は不可とする。
             * @param option.body - 職務経歴登録リクエストボディ
             */
            post: (option: { body: Methods_1vxxs3g['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1vxxs3g['post']['status']>(prefix, PATH110, POST, option).send(),
            /**
             * 職務経歴登録画面用の登録API。<br>
             * 汎用的に作るべきところを職務経歴登録画面のトランザクション管理のため、専用のAPIとして定義している。<br>
             * そのため、他画面での使用は不可とする。
             * @param option.body - 職務経歴登録リクエストボディ
             */
            $post: (option: { body: Methods_1vxxs3g['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1vxxs3g['post']['status']>(prefix, PATH110, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH110}`,
          },
          educations: {
            /**
             * ログイン候補者の学歴情報を取得します。
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1aulm0e['get']['resBody'], BasicHeaders, Methods_1aulm0e['get']['status']>(prefix, PATH112, GET, option).json(),
            /**
             * ログイン候補者の学歴情報を取得します。
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1aulm0e['get']['resBody'], BasicHeaders, Methods_1aulm0e['get']['status']>(prefix, PATH112, GET, option).json().then(r => r.body),
            /**
             * 候補者の学歴情報を登録します。
             * @param option.body - 学歴情報登録リクエストボディ
             */
            post: (option: { body: Methods_1aulm0e['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1aulm0e['post']['status']>(prefix, PATH112, POST, option).send(),
            /**
             * 候補者の学歴情報を登録します。
             * @param option.body - 学歴情報登録リクエストボディ
             */
            $post: (option: { body: Methods_1aulm0e['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1aulm0e['post']['status']>(prefix, PATH112, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH112}`,
          },
          languageSkills: {
            /**
             * ログイン中のユーザーに紐づく語学力情報を取得する。
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1f4lgnx['get']['resBody'], BasicHeaders, Methods_1f4lgnx['get']['status']>(prefix, PATH113, GET, option).json(),
            /**
             * ログイン中のユーザーに紐づく語学力情報を取得する。
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1f4lgnx['get']['resBody'], BasicHeaders, Methods_1f4lgnx['get']['status']>(prefix, PATH113, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH113}`,
          },
          page: {
            desiredConditions: {
              /**
               * 希望条件登録画面用の登録API。<br>
               * 汎用的に作るべきところを希望条件登録画面のトランザクション管理のため、専用のAPIとして定義している。<br>
               * そのため、他画面での使用は不可とする。
               */
              post: (option: { body: Methods_1ck0vqt['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ck0vqt['post']['status']>(prefix, PATH114, POST, option).send(),
              /**
               * 希望条件登録画面用の登録API。<br>
               * 汎用的に作るべきところを希望条件登録画面のトランザクション管理のため、専用のAPIとして定義している。<br>
               * そのため、他画面での使用は不可とする。
               */
              $post: (option: { body: Methods_1ck0vqt['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1ck0vqt['post']['status']>(prefix, PATH114, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH114}`,
            },
            languageQualification: {
              /**
               * Web履歴書の語学力・資格登録画面で利用する、画面内の複数リソース（語学・資格・在留資格）をまとめて更新するAPI。ログイン中のユーザーに紐付く語学・資格・在留資格登録情報を更新する。
               */
              post: (option: { body: Methods_1l1bg7a['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1l1bg7a['post']['status']>(prefix, PATH115, POST, option).send(),
              /**
               * Web履歴書の語学力・資格登録画面で利用する、画面内の複数リソース（語学・資格・在留資格）をまとめて更新するAPI。ログイン中のユーザーに紐付く語学・資格・在留資格登録情報を更新する。
               */
              $post: (option: { body: Methods_1l1bg7a['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1l1bg7a['post']['status']>(prefix, PATH115, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH115}`,
            },
          },
          profiles: {
            /**
             * ログイン中のユーザーのプロフィール情報を取得します。
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_45plg3['get']['resBody'], BasicHeaders, Methods_45plg3['get']['status']>(prefix, PATH116, GET, option).json(),
            /**
             * ログイン中のユーザーのプロフィール情報を取得します。
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_45plg3['get']['resBody'], BasicHeaders, Methods_45plg3['get']['status']>(prefix, PATH116, GET, option).json().then(r => r.body),
            /**
             * ログイン中のユーザーのプロフィール情報を更新します。
             */
            post: (option: { body: Methods_45plg3['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_45plg3['post']['status']>(prefix, PATH116, POST, option).send(),
            /**
             * ログイン中のユーザーのプロフィール情報を更新します。
             */
            $post: (option: { body: Methods_45plg3['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_45plg3['post']['status']>(prefix, PATH116, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH116}`,
          },
          residenceStatus: {
            /**
             * ログイン候補者の在留資格情報を取得します。
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1up23bt['get']['resBody'], BasicHeaders, Methods_1up23bt['get']['status']>(prefix, PATH117, GET, option).json(),
            /**
             * ログイン候補者の在留資格情報を取得します。
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1up23bt['get']['resBody'], BasicHeaders, Methods_1up23bt['get']['status']>(prefix, PATH117, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH117}`,
          },
        },
        savedSearches: {
          _no: (val3: string) => {
            const prefix3 = `${PATH118}/${val3}`;

            return {
              /**
               * 指定した検索条件を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_itimew['get']['resBody'], BasicHeaders, Methods_itimew['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した検索条件を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_itimew['get']['resBody'], BasicHeaders, Methods_itimew['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              /**
               * 指定した検索条件を更新する
               * @param option.body - 検索条件保存リクエストボディ
               */
              put: (option: { body: Methods_itimew['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_itimew['put']['status']>(prefix, prefix3, PUT, option).send(),
              /**
               * 指定した検索条件を更新する
               * @param option.body - 検索条件保存リクエストボディ
               */
              $put: (option: { body: Methods_itimew['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_itimew['put']['status']>(prefix, prefix3, PUT, option).send().then(r => r.body),
              /**
               * 指定した検索条件を削除する
               */
              delete: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods_itimew['delete']['status']>(prefix, prefix3, DELETE, option).send(),
              /**
               * 指定した検索条件を削除する
               */
              $delete: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods_itimew['delete']['status']>(prefix, prefix3, DELETE, option).send().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
          /**
           * ユーザーに紐づく検索条件を全て取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1arbdhu['get']['resBody'], BasicHeaders, Methods_1arbdhu['get']['status']>(prefix, PATH118, GET, option).json(),
          /**
           * ユーザーに紐づく検索条件を全て取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1arbdhu['get']['resBody'], BasicHeaders, Methods_1arbdhu['get']['status']>(prefix, PATH118, GET, option).json().then(r => r.body),
          /**
           * 指定した検索条件を保存する
           * @param option.body - 検索条件保存リクエストボディ
           */
          post: (option: { body: Methods_1arbdhu['post']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_1arbdhu['post']['status']>(prefix, PATH118, POST, option).send(),
          /**
           * 指定した検索条件を保存する
           * @param option.body - 検索条件保存リクエストボディ
           */
          $post: (option: { body: Methods_1arbdhu['post']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_1arbdhu['post']['status']>(prefix, PATH118, POST, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH118}`,
        },
        scout: {
          job: {
            _jid: (val4: string) => {
              const prefix4 = `${PATH119}/${val4}`;

              return {
                markAsRead: {
                  /**
                   * 指定した求人を閲覧済みとする。
                   * <br/>閲覧履歴の保存処理と閲覧履歴クッキーの付与を行う。
                   * <br/>リクエストパラメータにスカウトIDが存在し尚且つDR求人の場合は、専用の閲覧履歴の保存処理(スカウトメールの開封)を追加で行う。)
                   * @param option.body - スカウト求人リクエストボディ
                   */
                  post: (option: { body: Methods_1rp3slj['post']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_1rp3slj['post']['status']>(prefix, `${prefix4}${PATH75}`, POST, option).send(),
                  /**
                   * 指定した求人を閲覧済みとする。
                   * <br/>閲覧履歴の保存処理と閲覧履歴クッキーの付与を行う。
                   * <br/>リクエストパラメータにスカウトIDが存在し尚且つDR求人の場合は、専用の閲覧履歴の保存処理(スカウトメールの開封)を追加で行う。)
                   * @param option.body - スカウト求人リクエストボディ
                   */
                  $post: (option: { body: Methods_1rp3slj['post']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_1rp3slj['post']['status']>(prefix, `${prefix4}${PATH75}`, POST, option).send().then(r => r.body),
                  $path: () => `${prefix}${prefix4}${PATH75}`,
                },
                /**
                 * 指定した求人ID/スカウトIDから求人の詳細情報を取得する
                 * @returns 成功
                 */
                get: (option?: { query?: Methods_jr3h7h['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_jr3h7h['get']['resBody'], BasicHeaders, Methods_jr3h7h['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 指定した求人ID/スカウトIDから求人の詳細情報を取得する
                 * @returns 成功
                 */
                $get: (option?: { query?: Methods_jr3h7h['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                  fetch<Methods_jr3h7h['get']['resBody'], BasicHeaders, Methods_jr3h7h['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_jr3h7h['get']['query'] } | undefined) =>
                  `${prefix}${prefix4}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              };
            },
          },
        },
        selectJobs: {
          _selectJobCode: (val3: string) => {
            const prefix3 = `${PATH120}/${val3}`;

            return {
              reference: {
                /**
                 * 指定した特集コードに紐づくテーマが似ている求人特集一覧を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1en3614['get']['resBody'], BasicHeaders, Methods_1en3614['get']['status']>(prefix, `${prefix3}${PATH121}`, GET, option).json(),
                /**
                 * 指定した特集コードに紐づくテーマが似ている求人特集一覧を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1en3614['get']['resBody'], BasicHeaders, Methods_1en3614['get']['status']>(prefix, `${prefix3}${PATH121}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH121}`,
              },
              /**
               * 指定した特集コードから特集の詳細情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1y73qny['get']['resBody'], BasicHeaders, Methods_1y73qny['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した特集コードから特集の詳細情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1y73qny['get']['resBody'], BasicHeaders, Methods_1y73qny['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
          jobs: {
            count: {
              /**
               * 非推奨の特集求人一覧件数取得APIです。jobの POST /api/job/v1/featureJobs/jobs/countを使用してください。
               * @param option.body - 特集求人一覧検索条件リクエストボディ
               * @returns 成功
               */
              post: (option: { body: Methods_xnzz7g['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_xnzz7g['post']['resBody'], BasicHeaders, Methods_xnzz7g['post']['status']>(prefix, PATH123, POST, option).json(),
              /**
               * 非推奨の特集求人一覧件数取得APIです。jobの POST /api/job/v1/featureJobs/jobs/countを使用してください。
               * @param option.body - 特集求人一覧検索条件リクエストボディ
               * @returns 成功
               */
              $post: (option: { body: Methods_xnzz7g['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_xnzz7g['post']['resBody'], BasicHeaders, Methods_xnzz7g['post']['status']>(prefix, PATH123, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH123}`,
            },
            /**
             * 非推奨の特集求人一覧取得APIです。jobの POST /api/job/v1/featureJobs/jobを使用してください。
             * @param option.body - 特集求人一覧検索条件リクエストボディ
             * @returns 成功
             */
            post: (option: { body: Methods_1lob0jk['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_1lob0jk['post']['resBody'], BasicHeaders, Methods_1lob0jk['post']['status']>(prefix, PATH122, POST, option).json(),
            /**
             * 非推奨の特集求人一覧取得APIです。jobの POST /api/job/v1/featureJobs/jobを使用してください。
             * @param option.body - 特集求人一覧検索条件リクエストボディ
             * @returns 成功
             */
            $post: (option: { body: Methods_1lob0jk['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_1lob0jk['post']['resBody'], BasicHeaders, Methods_1lob0jk['post']['status']>(prefix, PATH122, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH122}`,
          },
        },
        selfPr: {
          samples: {
            _jobTypeMId: (val4: string) => {
              const prefix4 = `${PATH124}/${val4}`;

              return {
                /**
                 * 職種中分類に基づく自己PRのサンプルを取得する。
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_c3d0or['get']['resBody'], BasicHeaders, Methods_c3d0or['get']['status']>(prefix, prefix4, GET, option).json(),
                /**
                 * 職種中分類に基づく自己PRのサンプルを取得する。
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_c3d0or['get']['resBody'], BasicHeaders, Methods_c3d0or['get']['status']>(prefix, prefix4, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix4}`,
              };
            },
          },
        },
        user: {
          dodax: {
            application: {
              identification: {
                /**
                 * 受け取ったリクエストを元に、dodaX経由エントリー管理（TSTF176）にレコードを挿入する
                 * @param option.body - 応募判別情報登録リクエストボディ
                 */
                post: (option: { body: Methods_p1m3fr['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_p1m3fr['post']['status']>(prefix, PATH125, POST, option).send(),
                /**
                 * 受け取ったリクエストを元に、dodaX経由エントリー管理（TSTF176）にレコードを挿入する
                 * @param option.body - 応募判別情報登録リクエストボディ
                 */
                $post: (option: { body: Methods_p1m3fr['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_p1m3fr['post']['status']>(prefix, PATH125, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH125}`,
              },
            },
            convert: {
              agent: {
                /**
                 * dodaX経由でdoda会員情報を更新してエージェントサービスの登録を行う
                 * @param option.body - dodaX経由doda会員情報更新リクエストボディ
                 */
                patch: (option: { body: Methods_8s22kz['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_8s22kz['patch']['status']>(prefix, PATH127, PATCH, option).send(),
                /**
                 * dodaX経由でdoda会員情報を更新してエージェントサービスの登録を行う
                 * @param option.body - dodaX経由doda会員情報更新リクエストボディ
                 */
                $patch: (option: { body: Methods_8s22kz['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_8s22kz['patch']['status']>(prefix, PATH127, PATCH, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH127}`,
              },
              /**
               * dodaXから連携された情報でdodaに会員登録する
               * @param option.body - dodaX経由doda会員登録リクエストボディ
               */
              post: (option: { body: Methods_z8c2rx['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_z8c2rx['post']['status']>(prefix, PATH126, POST, option).send(),
              /**
               * dodaXから連携された情報でdodaに会員登録する
               * @param option.body - dodaX経由doda会員登録リクエストボディ
               */
              $post: (option: { body: Methods_z8c2rx['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_z8c2rx['post']['status']>(prefix, PATH126, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH126}`,
            },
          },
          service: {
            usageStatus: {
              /**
               * ログインユーザーのサービス利用状況を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_kzqanu['get']['resBody'], BasicHeaders, Methods_kzqanu['get']['status']>(prefix, PATH128, GET, option).json(),
              /**
               * ログインユーザーのサービス利用状況を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_kzqanu['get']['resBody'], BasicHeaders, Methods_kzqanu['get']['status']>(prefix, PATH128, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH128}`,
            },
          },
        },
        users: {
          account: {
            exists: {
              withDodaId: {
                /**
                 * 連携された情報でdoda/共通IDのアカウントが存在するか確認する
                 * @param option.body - doda/共通IDアカウント存在確認リクエストボディ
                 * @returns 成功
                 */
                post: (option: { body: Methods_r6amqk['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_r6amqk['post']['resBody'], BasicHeaders, Methods_r6amqk['post']['status']>(prefix, PATH131, POST, option).json(),
                /**
                 * 連携された情報でdoda/共通IDのアカウントが存在するか確認する
                 * @param option.body - doda/共通IDアカウント存在確認リクエストボディ
                 * @returns 成功
                 */
                $post: (option: { body: Methods_r6amqk['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_r6amqk['post']['resBody'], BasicHeaders, Methods_r6amqk['post']['status']>(prefix, PATH131, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH131}`,
              },
              /**
               * 連携された情報でdodaのアカウントが存在するか確認する
               * @param option.body - dodaアカウント存在確認リクエストボディ
               * @returns 成功
               */
              post: (option: { body: Methods_s6jemy['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_s6jemy['post']['resBody'], BasicHeaders, Methods_s6jemy['post']['status']>(prefix, PATH130, POST, option).json(),
              /**
               * 連携された情報でdodaのアカウントが存在するか確認する
               * @param option.body - dodaアカウント存在確認リクエストボディ
               * @returns 成功
               */
              $post: (option: { body: Methods_s6jemy['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_s6jemy['post']['resBody'], BasicHeaders, Methods_s6jemy['post']['status']>(prefix, PATH130, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH130}`,
            },
          },
          assessment: {
            annualSalary: {
              /**
               * ログインユーザーの年収査定情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_13rc1rs['get']['resBody'], BasicHeaders, Methods_13rc1rs['get']['status']>(prefix, PATH132, GET, option).json(),
              /**
               * ログインユーザーの年収査定情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_13rc1rs['get']['resBody'], BasicHeaders, Methods_13rc1rs['get']['status']>(prefix, PATH132, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH132}`,
            },
          },
          careers: {
            jobDescription: {
              /**
               * 指定番号の職務内容を更新する
               * @param option.body - 職務内容更新リクエストボディ
               */
              put: (option: { body: Methods_wonuzh['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_wonuzh['put']['status']>(prefix, PATH134, PUT, option).send(),
              /**
               * 指定番号の職務内容を更新する
               * @param option.body - 職務内容更新リクエストボディ
               */
              $put: (option: { body: Methods_wonuzh['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_wonuzh['put']['status']>(prefix, PATH134, PUT, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH134}`,
            },
            /**
             * ログインユーザーの職歴一覧情報を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j5k5e5['get']['resBody'], BasicHeaders, Methods_1j5k5e5['get']['status']>(prefix, PATH133, GET, option).json(),
            /**
             * ログインユーザーの職歴一覧情報を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1j5k5e5['get']['resBody'], BasicHeaders, Methods_1j5k5e5['get']['status']>(prefix, PATH133, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH133}`,
          },
          companyBlock: {
            dataMigration: {
              consent: {
                done: {
                  /**
                   * ログインユーザーの企業ブロック説明同意完了を登録する
                   */
                  post: (option?: { config?: T | undefined } | undefined) =>
                    fetch<void, BasicHeaders, Methods_48lxtp['post']['status']>(prefix, PATH137, POST, option).send(),
                  /**
                   * ログインユーザーの企業ブロック説明同意完了を登録する
                   */
                  $post: (option?: { config?: T | undefined } | undefined) =>
                    fetch<void, BasicHeaders, Methods_48lxtp['post']['status']>(prefix, PATH137, POST, option).send().then(r => r.body),
                  $path: () => `${prefix}${PATH137}`,
                },
                /**
                 * ログインユーザーの企業ブロック説明同意区分を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1fnuzb8['get']['resBody'], BasicHeaders, Methods_1fnuzb8['get']['status']>(prefix, PATH136, GET, option).json(),
                /**
                 * ログインユーザーの企業ブロック説明同意区分を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1fnuzb8['get']['resBody'], BasicHeaders, Methods_1fnuzb8['get']['status']>(prefix, PATH136, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH136}`,
              },
            },
            /**
             * 個人会員に紐づくブロック企業設定をすべて削除後、指定された企業IDのみブロックする。
             * @param option.body - 企業ブロック設定（複数件）リクエストボディ
             */
            put: (option: { body: Methods_1ryk6iy['put']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ryk6iy['put']['status']>(prefix, PATH135, PUT, option).send(),
            /**
             * 個人会員に紐づくブロック企業設定をすべて削除後、指定された企業IDのみブロックする。
             * @param option.body - 企業ブロック設定（複数件）リクエストボディ
             */
            $put: (option: { body: Methods_1ryk6iy['put']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ryk6iy['put']['status']>(prefix, PATH135, PUT, option).send().then(r => r.body),
            /**
             * 個人会員に紐づくブロック企業設定に、指定された企業IDを追加する。
             * @param option.body - 企業ブロック設定（1件）リクエストボディ
             */
            post: (option: { body: Methods_1ryk6iy['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ryk6iy['post']['status']>(prefix, PATH135, POST, option).send(),
            /**
             * 個人会員に紐づくブロック企業設定に、指定された企業IDを追加する。
             * @param option.body - 企業ブロック設定（1件）リクエストボディ
             */
            $post: (option: { body: Methods_1ryk6iy['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1ryk6iy['post']['status']>(prefix, PATH135, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH135}`,
          },
          dodax: {
            checkRegistration: {
              /**
               * dodaX連携判定（dodaX死活監視）を行う
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1a0lnsu['get']['resBody'], BasicHeaders, Methods_1a0lnsu['get']['status']>(prefix, PATH138, GET, option).json(),
              /**
               * dodaX連携判定（dodaX死活監視）を行う
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1a0lnsu['get']['resBody'], BasicHeaders, Methods_1a0lnsu['get']['status']>(prefix, PATH138, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH138}`,
            },
          },
          integration: {
            dodax: {
              agent: {
                /**
                 * dodaX連携会員情報を更新する
                 * @param option.body - dodaX連携会員情報更新リクエストボディ
                 */
                patch: (option: { body: Methods_1ihierz['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1ihierz['patch']['status']>(prefix, PATH140, PATCH, option).send(),
                /**
                 * dodaX連携会員情報を更新する
                 * @param option.body - dodaX連携会員情報更新リクエストボディ
                 */
                $patch: (option: { body: Methods_1ihierz['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_1ihierz['patch']['status']>(prefix, PATH140, PATCH, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH140}`,
              },
              /**
               * dodaXから連携された情報でdodaに会員登録する
               * @param option.body - dodaX連携会員登録リクエストボディ
               */
              post: (option: { body: Methods_1w5ssoh['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1w5ssoh['post']['status']>(prefix, PATH139, POST, option).send(),
              /**
               * dodaXから連携された情報でdodaに会員登録する
               * @param option.body - dodaX連携会員登録リクエストボディ
               */
              $post: (option: { body: Methods_1w5ssoh['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1w5ssoh['post']['status']>(prefix, PATH139, POST, option).send().then(r => r.body),
              $path: () => `${prefix}${PATH139}`,
            },
          },
          overseasPostingCareers: {
            /**
             * ログインユーザーの海外赴任経歴を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_hubz5h['get']['resBody'], BasicHeaders, Methods_hubz5h['get']['status']>(prefix, PATH141, GET, option).json(),
            /**
             * ログインユーザーの海外赴任経歴を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_hubz5h['get']['resBody'], BasicHeaders, Methods_hubz5h['get']['status']>(prefix, PATH141, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH141}`,
          },
          pino: {
            agreement: {
              /**
               * 指定した期間と指定した範囲のPINO規約同意ユーザーを取得する
               * @returns 成功
               */
              get: (option: { query: Methods_1awuzlh['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1awuzlh['get']['resBody'], BasicHeaders, Methods_1awuzlh['get']['status']>(prefix, PATH142, GET, option).json(),
              /**
               * 指定した期間と指定した範囲のPINO規約同意ユーザーを取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_1awuzlh['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1awuzlh['get']['resBody'], BasicHeaders, Methods_1awuzlh['get']['status']>(prefix, PATH142, GET, option).json().then(r => r.body),
              /**
               * PINO規約同意ユーザーを登録する
               * @param option.body - PINO規約同意ユーザー登録リクエストボディ
               */
              post: (option: { body: Methods_1awuzlh['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1awuzlh['post']['status']>(prefix, PATH142, POST, option).send(),
              /**
               * PINO規約同意ユーザーを登録する
               * @param option.body - PINO規約同意ユーザー登録リクエストボディ
               */
              $post: (option: { body: Methods_1awuzlh['post']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1awuzlh['post']['status']>(prefix, PATH142, POST, option).send().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1awuzlh['get']['query'] } | undefined) =>
                `${prefix}${PATH142}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          qualifications: {
            /**
             * ログインユーザーの資格情報を取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1fw831s['get']['resBody'], BasicHeaders, Methods_1fw831s['get']['status']>(prefix, PATH143, GET, option).json(),
            /**
             * ログインユーザーの資格情報を取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1fw831s['get']['resBody'], BasicHeaders, Methods_1fw831s['get']['status']>(prefix, PATH143, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH143}`,
          },
          registration: {
            crypto: {
              encrypt: {
                /**
                 * 平文をAES暗号化して返す
                 * @returns 成功
                 */
                post: (option: { body: Methods_maksvn['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_maksvn['post']['resBody'], BasicHeaders, Methods_maksvn['post']['status']>(prefix, PATH145, POST, option).json(),
                /**
                 * 平文をAES暗号化して返す
                 * @returns 成功
                 */
                $post: (option: { body: Methods_maksvn['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_maksvn['post']['resBody'], BasicHeaders, Methods_maksvn['post']['status']>(prefix, PATH145, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH145}`,
              },
            },
            master: {
              days: {
                /**
                 * 年月に応じたその月の日リスト取得
                 * @returns 成功
                 */
                get: (option: { query: Methods_17pc9a4['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_17pc9a4['get']['resBody'], BasicHeaders, Methods_17pc9a4['get']['status']>(prefix, PATH146, GET, option).json(),
                /**
                 * 年月に応じたその月の日リスト取得
                 * @returns 成功
                 */
                $get: (option: { query: Methods_17pc9a4['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_17pc9a4['get']['resBody'], BasicHeaders, Methods_17pc9a4['get']['status']>(prefix, PATH146, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_17pc9a4['get']['query'] } | undefined) =>
                  `${prefix}${PATH146}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              employmentStatusForPersonal: {
                /**
                 * 雇用形態マスタ取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_16wsz1a['get']['resBody'], BasicHeaders, Methods_16wsz1a['get']['status']>(prefix, PATH147, GET, option).json(),
                /**
                 * 雇用形態マスタ取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_16wsz1a['get']['resBody'], BasicHeaders, Methods_16wsz1a['get']['status']>(prefix, PATH147, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH147}`,
              },
              gender: {
                /**
                 * 性別マスタ取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_2yo45e['get']['resBody'], BasicHeaders, Methods_2yo45e['get']['status']>(prefix, PATH148, GET, option).json(),
                /**
                 * 性別マスタ取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_2yo45e['get']['resBody'], BasicHeaders, Methods_2yo45e['get']['status']>(prefix, PATH148, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH148}`,
              },
              graduationCalendar: {
                /**
                 * 卒業年月早見表の年リスト取得
                 * @returns 成功
                 */
                get: (option: { query: Methods_1ey31d1['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1ey31d1['get']['resBody'], BasicHeaders, Methods_1ey31d1['get']['status']>(prefix, PATH149, GET, option).json(),
                /**
                 * 卒業年月早見表の年リスト取得
                 * @returns 成功
                 */
                $get: (option: { query: Methods_1ey31d1['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1ey31d1['get']['resBody'], BasicHeaders, Methods_1ey31d1['get']['status']>(prefix, PATH149, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_1ey31d1['get']['query'] } | undefined) =>
                  `${prefix}${PATH149}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              graduationStatus: {
                /**
                 * 卒業区分一覧取得
                 * @returns 成功
                 */
                get: (option: { query: Methods_1ddsgg1['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1ddsgg1['get']['resBody'], BasicHeaders, Methods_1ddsgg1['get']['status']>(prefix, PATH150, GET, option).json(),
                /**
                 * 卒業区分一覧取得
                 * @returns 成功
                 */
                $get: (option: { query: Methods_1ddsgg1['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_1ddsgg1['get']['resBody'], BasicHeaders, Methods_1ddsgg1['get']['status']>(prefix, PATH150, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_1ddsgg1['get']['query'] } | undefined) =>
                  `${prefix}${PATH150}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              jobChangeTimes: {
                /**
                 * 転職回数マスタ取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1lbxx2c['get']['resBody'], BasicHeaders, Methods_1lbxx2c['get']['status']>(prefix, PATH151, GET, option).json(),
                /**
                 * 転職回数マスタ取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1lbxx2c['get']['resBody'], BasicHeaders, Methods_1lbxx2c['get']['status']>(prefix, PATH151, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH151}`,
              },
              prefectures: {
                /**
                 * 都道府県一覧取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1kehc1x['get']['resBody'], BasicHeaders, Methods_1kehc1x['get']['status']>(prefix, PATH152, GET, option).json(),
                /**
                 * 都道府県一覧取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1kehc1x['get']['resBody'], BasicHeaders, Methods_1kehc1x['get']['status']>(prefix, PATH152, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH152}`,
              },
              schoolClassification: {
                /**
                 * 最終学歴マスタ取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_163hsu7['get']['resBody'], BasicHeaders, Methods_163hsu7['get']['status']>(prefix, PATH153, GET, option).json(),
                /**
                 * 最終学歴マスタ取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_163hsu7['get']['resBody'], BasicHeaders, Methods_163hsu7['get']['status']>(prefix, PATH153, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH153}`,
              },
              workingStatus: {
                /**
                 * 直近の勤務状況取得
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_tf9w78['get']['resBody'], BasicHeaders, Methods_tf9w78['get']['status']>(prefix, PATH154, GET, option).json(),
                /**
                 * 直近の勤務状況取得
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_tf9w78['get']['resBody'], BasicHeaders, Methods_tf9w78['get']['status']>(prefix, PATH154, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH154}`,
              },
              years: {
                /**
                 * 年リスト取得
                 * @returns 成功
                 */
                get: (option: { query: Methods_c95otj['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_c95otj['get']['resBody'], BasicHeaders, Methods_c95otj['get']['status']>(prefix, PATH155, GET, option).json(),
                /**
                 * 年リスト取得
                 * @returns 成功
                 */
                $get: (option: { query: Methods_c95otj['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_c95otj['get']['resBody'], BasicHeaders, Methods_c95otj['get']['status']>(prefix, PATH155, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_c95otj['get']['query'] } | undefined) =>
                  `${prefix}${PATH155}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            },
            /**
             * @param option.body - 会員登録リクエストボディ
             * @returns 成功
             */
            post: (option: { body: Methods_1kxch4v['post']['reqBody'], headers?: Methods_1kxch4v['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<Methods_1kxch4v['post']['resBody'], BasicHeaders, Methods_1kxch4v['post']['status']>(prefix, PATH144, POST, option).json(),
            /**
             * @param option.body - 会員登録リクエストボディ
             * @returns 成功
             */
            $post: (option: { body: Methods_1kxch4v['post']['reqBody'], headers?: Methods_1kxch4v['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<Methods_1kxch4v['post']['resBody'], BasicHeaders, Methods_1kxch4v['post']['status']>(prefix, PATH144, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH144}`,
          },
          selection: {
            documents: {
              capturing: {
                /**
                 * 連携された個人顧客選考書類取り寄せ情報をdodaに取り込む
                 * @param option.body - 個人顧客選考書類取り寄せ依頼リクエストボディ
                 */
                post: (option: { body: Methods_glfomf['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_glfomf['post']['status']>(prefix, PATH157, POST, option).send(),
                /**
                 * 連携された個人顧客選考書類取り寄せ情報をdodaに取り込む
                 * @param option.body - 個人顧客選考書類取り寄せ依頼リクエストボディ
                 */
                $post: (option: { body: Methods_glfomf['post']['reqBody'], config?: T | undefined }) =>
                  fetch<void, BasicHeaders, Methods_glfomf['post']['status']>(prefix, PATH157, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${PATH157}`,
              },
              download: {
                /**
                 * 指定の書類ファイルデータをダウンロードする
                 * @returns 成功
                 */
                get: (option: { query: Methods_qhsoy6['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_qhsoy6['get']['resBody'], BasicHeaders, Methods_qhsoy6['get']['status']>(prefix, PATH158, GET, option).json(),
                /**
                 * 指定の書類ファイルデータをダウンロードする
                 * @returns 成功
                 */
                $get: (option: { query: Methods_qhsoy6['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_qhsoy6['get']['resBody'], BasicHeaders, Methods_qhsoy6['get']['status']>(prefix, PATH158, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_qhsoy6['get']['query'] } | undefined) =>
                  `${prefix}${PATH158}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              histories: {
                /**
                 * 候補者＆案件ごとに、回収対象の書類情報の履歴一覧を取得する
                 * @returns 成功
                 */
                get: (option: { query: Methods_ygkrx2['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ygkrx2['get']['resBody'], BasicHeaders, Methods_ygkrx2['get']['status']>(prefix, PATH159, GET, option).json(),
                /**
                 * 候補者＆案件ごとに、回収対象の書類情報の履歴一覧を取得する
                 * @returns 成功
                 */
                $get: (option: { query: Methods_ygkrx2['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ygkrx2['get']['resBody'], BasicHeaders, Methods_ygkrx2['get']['status']>(prefix, PATH159, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_ygkrx2['get']['query'] } | undefined) =>
                  `${prefix}${PATH159}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              orderInfo: {
                /**
                 * 個人顧客選考書類取り寄せ情報を取得する
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_wteuny['get']['resBody'], BasicHeaders, Methods_wteuny['get']['status']>(prefix, PATH160, GET, option).json(),
                /**
                 * 個人顧客選考書類取り寄せ情報を取得する
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_wteuny['get']['resBody'], BasicHeaders, Methods_wteuny['get']['status']>(prefix, PATH160, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH160}`,
              },
              /**
               * 候補者＆案件ごとに、回収対象の書類情報を取得する
               * @returns 成功
               */
              get: (option: { query: Methods_1y50ktp['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1y50ktp['get']['resBody'], BasicHeaders, Methods_1y50ktp['get']['status']>(prefix, PATH156, GET, option).json(),
              /**
               * 候補者＆案件ごとに、回収対象の書類情報を取得する
               * @returns 成功
               */
              $get: (option: { query: Methods_1y50ktp['get']['query'], config?: T | undefined }) =>
                fetch<Methods_1y50ktp['get']['resBody'], BasicHeaders, Methods_1y50ktp['get']['status']>(prefix, PATH156, GET, option).json().then(r => r.body),
              /**
               * 個人顧客選考書類をアップロードする
               * @param option.body - 個人顧客選考書類アップロードリクエストボディ
               */
              put: (option: { body: Methods_1y50ktp['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1y50ktp['put']['status']>(prefix, PATH156, PUT, option).send(),
              /**
               * 個人顧客選考書類をアップロードする
               * @param option.body - 個人顧客選考書類アップロードリクエストボディ
               */
              $put: (option: { body: Methods_1y50ktp['put']['reqBody'], config?: T | undefined }) =>
                fetch<void, BasicHeaders, Methods_1y50ktp['put']['status']>(prefix, PATH156, PUT, option).send().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_1y50ktp['get']['query'] } | undefined) =>
                `${prefix}${PATH156}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          selfPr: {
            /**
             * 個人顧客の自己PRを取得する
             * @returns 成功
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1l84wo6['get']['resBody'], BasicHeaders, Methods_1l84wo6['get']['status']>(prefix, PATH161, GET, option).json(),
            /**
             * 個人顧客の自己PRを取得する
             * @returns 成功
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1l84wo6['get']['resBody'], BasicHeaders, Methods_1l84wo6['get']['status']>(prefix, PATH161, GET, option).json().then(r => r.body),
            /**
             * 個人顧客の自己PRを更新する
             * @param option.body - 自己PR更新リクエストボディ
             */
            post: (option: { body: Methods_1l84wo6['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1l84wo6['post']['status']>(prefix, PATH161, POST, option).send(),
            /**
             * 個人顧客の自己PRを更新する
             * @param option.body - 自己PR更新リクエストボディ
             */
            $post: (option: { body: Methods_1l84wo6['post']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_1l84wo6['post']['status']>(prefix, PATH161, POST, option).send().then(r => r.body),
            $path: () => `${prefix}${PATH161}`,
          },
          service: {
            jobOffer: {
              usageStatus: {
                /**
                 * ログインユーザーの求人紹介サービス利用状況を取得する。<br>
                 * 類似APIとして個人顧客サービス利用状況取得API(GET /api/v1/user/service/usageStatus)が存在するが、<br>
                 * このAPIは抽象度が高く、エンドポイントだけを見ると様々な拡張が可能なつくりとなっている。<br>
                 * 抽象度が高いまま拡張を重ねるのは適切ではないと判断し、明確な役割のAPIとして本APIを定義している。
                 * @returns 成功
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_fao6xz['get']['resBody'], BasicHeaders, Methods_fao6xz['get']['status']>(prefix, PATH162, GET, option).json(),
                /**
                 * ログインユーザーの求人紹介サービス利用状況を取得する。<br>
                 * 類似APIとして個人顧客サービス利用状況取得API(GET /api/v1/user/service/usageStatus)が存在するが、<br>
                 * このAPIは抽象度が高く、エンドポイントだけを見ると様々な拡張が可能なつくりとなっている。<br>
                 * 抽象度が高いまま拡張を重ねるのは適切ではないと判断し、明確な役割のAPIとして本APIを定義している。
                 * @returns 成功
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_fao6xz['get']['resBody'], BasicHeaders, Methods_fao6xz['get']['status']>(prefix, PATH162, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH162}`,
              },
            },
          },
          /**
           * ログインユーザーの会員情報を取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_r5qu0t['get']['resBody'], BasicHeaders, Methods_r5qu0t['get']['status']>(prefix, PATH129, GET, option).json(),
          /**
           * ログインユーザーの会員情報を取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_r5qu0t['get']['resBody'], BasicHeaders, Methods_r5qu0t['get']['status']>(prefix, PATH129, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH129}`,
        },
        visaType: {
          /**
           * 査証区分マスタと在留資格区分マスタをセットで取得する
           * @returns 成功
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1mgkiqi['get']['resBody'], BasicHeaders, Methods_1mgkiqi['get']['status']>(prefix, PATH163, GET, option).json(),
          /**
           * 査証区分マスタと在留資格区分マスタをセットで取得する
           * @returns 成功
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_1mgkiqi['get']['resBody'], BasicHeaders, Methods_1mgkiqi['get']['status']>(prefix, PATH163, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH163}`,
        },
      },
      v2: {
        industry: {
          /**
           * 業種マスタ取得API。
           *
           * バージョン1では、検索用業種マスタのみを返却しているが、バージョン2では、 業種マスタと検索用業種マスタをセットで取得する。
           * @returns 成功
           */
          get: (option?: { query?: Methods_w9dtta['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_w9dtta['get']['resBody'], BasicHeaders, Methods_w9dtta['get']['status']>(prefix, PATH164, GET, option).json(),
          /**
           * 業種マスタ取得API。
           *
           * バージョン1では、検索用業種マスタのみを返却しているが、バージョン2では、 業種マスタと検索用業種マスタをセットで取得する。
           * @returns 成功
           */
          $get: (option?: { query?: Methods_w9dtta['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_w9dtta['get']['resBody'], BasicHeaders, Methods_w9dtta['get']['status']>(prefix, PATH164, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_w9dtta['get']['query'] } | undefined) =>
            `${prefix}${PATH164}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        job: {
          _jid: (val3: string) => {
            const prefix3 = `${PATH165}/${val3}`;

            return {
              /**
               * 指定した求人IDから求人の詳細情報を取得する
               * @returns 成功
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_aehoyt['get']['resBody'], BasicHeaders, Methods_aehoyt['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * 指定した求人IDから求人の詳細情報を取得する
               * @returns 成功
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_aehoyt['get']['resBody'], BasicHeaders, Methods_aehoyt['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
        },
        jobs: {
          neararea: {
            /**
             * 指定した検索条件から近隣エリアの求人一覧を取得する
             * @returns 成功
             */
            get: (option: { query: Methods_wuu0lu['get']['query'], config?: T | undefined }) =>
              fetch<Methods_wuu0lu['get']['resBody'], BasicHeaders, Methods_wuu0lu['get']['status']>(prefix, PATH167, GET, option).json(),
            /**
             * 指定した検索条件から近隣エリアの求人一覧を取得する
             * @returns 成功
             */
            $get: (option: { query: Methods_wuu0lu['get']['query'], config?: T | undefined }) =>
              fetch<Methods_wuu0lu['get']['resBody'], BasicHeaders, Methods_wuu0lu['get']['status']>(prefix, PATH167, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_wuu0lu['get']['query'] } | undefined) =>
              `${prefix}${PATH167}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          /**
           * 指定した検索条件から求人一覧を取得する
           * @returns 成功
           */
          get: (option?: { query?: Methods_10brc48['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_10brc48['get']['resBody'], BasicHeaders, Methods_10brc48['get']['status']>(prefix, PATH166, GET, option).json(),
          /**
           * 指定した検索条件から求人一覧を取得する
           * @returns 成功
           */
          $get: (option?: { query?: Methods_10brc48['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_10brc48['get']['resBody'], BasicHeaders, Methods_10brc48['get']['status']>(prefix, PATH166, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_10brc48['get']['query'] } | undefined) =>
            `${prefix}${PATH166}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        users: {
          registration: {
            /**
             * @param option.body - 会員登録リクエストボディ
             * @returns 成功
             */
            post: (option: { body: Methods_r3ayx4['post']['reqBody'], headers?: Methods_r3ayx4['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<Methods_r3ayx4['post']['resBody'], BasicHeaders, Methods_r3ayx4['post']['status']>(prefix, PATH168, POST, option).json(),
            /**
             * @param option.body - 会員登録リクエストボディ
             * @returns 成功
             */
            $post: (option: { body: Methods_r3ayx4['post']['reqBody'], headers?: Methods_r3ayx4['post']['reqHeaders'] | undefined, config?: T | undefined }) =>
              fetch<Methods_r3ayx4['post']['resBody'], BasicHeaders, Methods_r3ayx4['post']['status']>(prefix, PATH168, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH168}`,
          },
        },
      },
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
